(function () {
  'use strict';

  class Dom {
    static nodeListToArray(nodeList, filter) {
      var items = [];

      for (var i = 0; i !== nodeList.length; ++i) {
        if (!filter || nodeList[i].matches(filter)) {
          items.push(nodeList[i]);
        }
      }

      return items;
    }

  }

  class CountrySelector {
    constructor(countrySelect, provinceSelect) {
      this.countrySelect = countrySelect;
      this.provinceSelect = provinceSelect;

      if (this.countrySelect && this.provinceSelect) {
        this._bindEventsListeners();

        this._initSelectors();
      }
    }

    destroy() {
      if (this.countrySelect) {
        this.countrySelect.removeEventListener('change', this._onCountryChangedListener);
      }
    }

    _initSelectors() {
      // Check first the default value of country
      var defaultCountry = this.countrySelect.getAttribute('data-default');

      if (defaultCountry) {
        for (var i = 0; i !== this.countrySelect.options.length; ++i) {
          if (this.countrySelect.options[i].text === defaultCountry) {
            this.countrySelect.selectedIndex = i;
            break;
          }
        }
      } else {
        this.countrySelect.selectedIndex = 0;
      }

      var event = new Event('change', {
        bubbles: true
      });
      this.countrySelect.dispatchEvent(event); // Then the province

      var defaultProvince = this.provinceSelect.getAttribute('data-default');

      if (defaultProvince) {
        this.provinceSelect.value = defaultProvince;
      }
    }

    _bindEventsListeners() {
      this._onCountryChangedListener = this._onCountryChanged.bind(this);
      this.countrySelect.addEventListener('change', this._onCountryChangedListener);
    }

    _onCountryChanged() {
      var _this = this;

      var selectedOption = this.countrySelect.options[this.countrySelect.selectedIndex],
          provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]'); // First remove all options

      this.provinceSelect.innerHTML = '';

      if (provinces.length === 0) {
        this.provinceSelect.parentNode.parentNode.style.display = 'none';
        return;
      } // We need to build the provinces array


      provinces.forEach(function (data) {
        _this.provinceSelect.options.add(new Option(data[1], data[0]));
      });
      this.provinceSelect.parentNode.parentNode.style.display = 'block';
    }

  }

  class AddressesSection {
    constructor() {
      var _this = this;

      this.countrySelectors = [];
      Dom.nodeListToArray(document.querySelectorAll('.Modal--address')).forEach(function (modal) {
        _this.countrySelectors.push(new CountrySelector(modal.querySelector('[name="address[country]"]'), modal.querySelector('[name="address[province]"]')));
      });
    }

  }

  class Responsive {
    constructor(name) {
      var _this = this;

      this.currentBreakpoint = Responsive.getCurrentBreakpoint();
      window.addEventListener('resize', function () {
        var newBreakpoint = Responsive.getCurrentBreakpoint();

        if (_this.currentBreakpoint === newBreakpoint) {
          return;
        }

        document.dispatchEvent(new CustomEvent('breakpoint:changed', {
          detail: {
            previousBreakpoint: _this.currentBreakpoint,
            currentBreakpoint: newBreakpoint
          }
        }));
        _this.currentBreakpoint = newBreakpoint;
      });
    }

    static matchesBreakpoint(breakpoint) {
      switch (breakpoint) {
        case 'small':
          return window.matchMedia('screen and (max-width: 640px)').matches;

        case 'medium':
          return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

        case 'large':
          return window.matchMedia('screen and (min-width: 1008px)').matches;

        case 'x-large':
          return window.matchMedia('screen and (min-width: 1280px)').matches;

        case 'x-x-large':
          return window.matchMedia('screen and (min-width: 1600px)').matches;

        case 'medium-up':
          return window.matchMedia('screen and (min-width: 641px)').matches;

        case 'medium-down':
          return window.matchMedia('screen and (max-width: 1007px)').matches;
      }
    }

    static getCurrentBreakpoint() {
      if (window.matchMedia('screen and (max-width: 640px)').matches) {
        return 'small';
      }

      if (window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches) {
        return 'medium';
      }

      if (window.matchMedia('screen and (min-width: 1600px)').matches) {
        return 'x-x-large';
      } else if (window.matchMedia('screen and (min-width: 1280px)').matches) {
        return 'x-large';
      }

      if (window.matchMedia('screen and (min-width: 1008px)').matches) {
        return 'large';
      }
    }

  }

  class Carousel {
    constructor(element) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let overrideSettings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.element = element;
      let readyEvent = {
        on: {
          ready: function () {
            element.classList.add("flickity-ready");
          }
        }
      };
      this.initialConfig = Object.assign(JSON.parse(element.getAttribute('data-flickity-config')), overrideSettings, readyEvent);
      this.options = options;

      this._bindEventsListeners();

      this._build();
    }

    destroy() {
      this.flickityInstance.destroy();

      if (this.initialConfig['breakpoints'] !== undefined) {
        document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }

    getFlickityInstance() {
      return this.flickityInstance;
    }

    selectCell(index) {
      var shouldPause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var shouldAnimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (shouldPause) {
        this.flickityInstance.pausePlayer();
      }

      this.flickityInstance.select(index, false, !shouldAnimate);
    }

    next() {
      this.flickityInstance.next();
    }

    previous() {
      this.flickityInstance.previous();
    }

    pausePlayer() {
      this.flickityInstance.pausePlayer();
    }

    unpausePlayer() {
      this.flickityInstance.unpausePlayer();
    }

    resize() {
      this.flickityInstance.resize();
    }

    getSelectedIndex() {
      return this.flickityInstance.selectedIndex;
    }

    getSelectedCell() {
      return this.flickityInstance.selectedCell.element;
    }

    _bindEventsListeners() {
      if (this.initialConfig['breakpoints'] !== undefined) {
        this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
        document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
      }
    }

    _build() {
      var _this = this;

      var config = this._processConfig();

      this.flickityInstance = new Flickity(this.element, config);

      this._validateDraggable();

      this.selectedIndex = this.flickityInstance.selectedIndex;
      this.flickityInstance.on('resize', this._validateDraggable.bind(this)); //  this.flickityInstance.on('change', function (){_this.element.classList.add("flickity-ready");}); 

      if (this.options['onSelect']) {
        this.flickityInstance.on('select', function () {
          // Flickity will send the "select" event whenever the window resize (even on mobile...), as a consequence we need to check 
          // first if the slide index have changed or not (cf: https://github.com/metafizzy/flickity/issues/529)
          if (_this.selectedIndex !== _this.flickityInstance.selectedIndex) {
            _this.options['onSelect'](_this.flickityInstance.selectedIndex, _this.flickityInstance.selectedCell.element);

            _this.selectedIndex = _this.flickityInstance.selectedIndex;
          }
        });
      }

      if (this.options['onSettle']) {
        this.flickityInstance.on('settle', function (index) {
          _this.options['onSettle'](index, _this.flickityInstance.selectedCell.element);
        });
      }

      if (this.options['onClick']) {
        this.flickityInstance.on('staticClick', function (event, pointer, cell, index) {
          _this.options['onClick'](cell, index);
        });
      }
    }

    _validateDraggable() {
      var isActive = this.flickityInstance.isActive || false;
      this.element.classList.add("flickity-ready");

      if (!isActive || !this.flickityInstance.options['draggable']) {
        return;
      }

      if (undefined === this.flickityInstance.selectedElements || this.flickityInstance.selectedElements.length === this.flickityInstance.cells.length) {
        this.flickityInstance.unbindDrag();
      } else {
        this.flickityInstance.bindDrag();
      }
    }

    _processConfig() {
      var config = Object.assign({}, this.initialConfig);
      delete config['breakpoints'];

      if (this.initialConfig['breakpoints'] === undefined) {
        return config; // No change, we simply return the config as it is
      }

      var breakpoints = this.initialConfig['breakpoints'];
      breakpoints.forEach(function (breakpoint) {
        if (Responsive.matchesBreakpoint(breakpoint['matches'])) {
          config = Object.assign(config, breakpoint['settings']);
        }
      });
      return config;
    }

    _onBreakpointChanged() {
      this.flickityInstance.destroy();
      this.element.classList.remove("flickity-ready");

      this._build();
    }

  }

  class SlideshowSection {
    constructor(container) {
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.carousel = new Carousel(this.element.querySelector(".Carousel"), {
        onSelect: this._onSlideChanged.bind(this)
      });
      this.selectedSlide = null;
      this.preEnterSlide = null;
      this.enableAnimate = true;
      this.timeline = themegoal.libs.anime.timeline();
      this.timeoffsets = 0;
      this.imageBreakpoint = Responsive.getCurrentBreakpoint();

      if (this.imageBreakpoint != "small") {
        this.imageBreakpoint = "medium-up";
      }

      if (this.carousel.flickityInstance.cells.length > 0) {
        this._transitionSlide(this.carousel.flickityInstance.selectedCell.element);
      }

      this._bindEventsListeners();
    }

    onUnload() {
      this.carousel.destroy();
      this.timeline = null;
      this.delegateElement.off();
      document.removeEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }

    onBlockSelect(event) {
      if (this.carousel.flickityInstance.options.autoPlay) {
        this.carousel.flickityInstance.stopPlayer();
      }

      this.enableAnimate = !event.detail.load;
      this.carousel.selectCell(event.target.getAttribute('data-slide-index'), false, !event.detail.load);
    }

    onBlockDeselect() {
      this.enableAnimate = true;

      if (this.carousel.flickityInstance.options.autoPlay) {
        this.carousel.flickityInstance.playPlayer();
      }
    }

    _bindEventsListeners() {
      this._onBreakpointChangedListener = this._onBreakpointChanged.bind(this);
      this.delegateElement.on('mouseenter', '.Button', this._pauseSlideshow.bind(this), true);
      this.delegateElement.on('mouseleave', '.Button', this._resumeSlideshow.bind(this), true);
      document.addEventListener('breakpoint:changed', this._onBreakpointChangedListener);
    }

    _pauseSlideshow() {
      if (this.carousel.flickityInstance.options.autoPlay) {
        this.carousel.flickityInstance.pausePlayer();
      }
    }

    _resumeSlideshow() {
      if (this.carousel.flickityInstance.options.autoPlay) {
        this.carousel.flickityInstance.unpausePlayer();
      }
    }

    _onSlideChanged(index, element) {
      this._transitionSlide(element);
    }

    _transitionSlide(slide) {
      var _this = this;

      this.timeline = themegoal.libs.anime.timeline();

      if (this.selectedSlide) {
        this.timeoffsets = this.enableAnimate ? '-=400' : 0;
      }

      this.timeline.add({
        targets: slide,
        opacity: [0, 1],
        duration: _this.selectedSlide && _this.enableAnimate ? 300 : 0,
        easing: 'easeInOutCubic'
      }, _this.timeoffsets);

      if (this.carousel.flickityInstance.options.autoPlay && this.carousel.flickityInstance.player.state === 'playing') {
        this.carousel.flickityInstance.pausePlayer();
      }

      let image = slide.querySelector('.Slideshow__Image.Slideshow__Image--' + _this.imageBreakpoint);

      if (image) {
        _this._transitionSlideContent(slide);
      }
      this.selectedSlide = slide;
    }

    _transitionSlideContent(slide) {
      if (this.preEnterSlide != null && this.preEnterSlide == slide) return;
      this.preEnterSlide = slide;

      var _this = this;

      var images = slide.querySelectorAll('.Slideshow__Image'),
          content = slide.querySelector('.SectionHeader'),
          buttonWrapper = slide.querySelector('.SectionHeader__ButtonWrapper');

      if (this.carousel.flickityInstance.options.autoPlay && this.carousel.flickityInstance.player.state === 'paused') {
        this.carousel.flickityInstance.unpausePlayer();
      }

      this.timeline.add({
        targets: images,
        opacity: [0, 1],
        scale: [1.2, 1],
        duration: _this.enableAnimate ? 1200 : 0,
        easing: 'easeOutQuad'
      }, _this.timeoffsets);

      if (content) {
        this.timeline.add({
          targets: content,
          opacity: [0, 1],
          translateY: [30, 0],
          duration: _this.enableAnimate ? 800 : 0,
          delay: _this.enableAnimate ? 800 : 0,
          easing: 'easeOutCubic'
        }, _this.timeoffsets);
      }

      if (buttonWrapper) {
        this.timeline.add({
          targets: buttonWrapper,
          opacity: [0, 1],
          translateY: [20, 0],
          duration: _this.enableAnimate ? 800 : 0,
          delay: _this.enableAnimate ? 800 : 0,
          easing: 'easeOutCubic'
        }, _this.timeoffsets);
      }
    }

    _onBreakpointChanged(event) {
      this.imageBreakpoint = Responsive.getCurrentBreakpoint();

      if (this.imageBreakpoint != "small") {
        this.imageBreakpoint = "medium-up";
      }

      if (event.detail.previousBreakpoint === 'small' && event.detail.currentBreakpoint !== 'small' || event.detail.previousBreakpoint !== 'small' && event.detail.currentBreakpoint === 'small') {
        this.selectedSlide = null;

        if (this.carousel.flickityInstance.cells.length > 0) {
          this._transitionSlide(this.carousel.flickityInstance.selectedElement);
        }
      }
    }

  }

  class AnnouncementBarSection {
    constructor(element) {
      this.element = element;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(element.getAttribute('data-section-settings'));

      try {
        if (this.options['closeable'] && sessionStorage.getItem('AnnoucementClosed') === null) {
          this._openAnnoucement();
        }
      } catch (error) {}

      this._bindEventsListeners();
    }

    onUnload() {
      this.delegateElement.off();
    }

    onSelect() {
      if (this.options['closeable']) {
        this._openAnnoucement();
      }
    }

    onDeselect() {// if (this.options['closeable']) {
      //     this._closeAnnoucement();
      // }
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '[data-action="close-annoucement"]', this._closeAnnoucement.bind(this));
    }

    _openAnnoucement() {
      this.element.setAttribute('aria-hidden', 'false');
      document.documentElement.style.setProperty('--tg-announcement-bar-height', document.getElementById('shopify-section-announcement-bar').offsetHeight + 'px');
    }

    _closeAnnoucement() {
      sessionStorage.setItem('AnnoucementClosed', 'true');

      if (this.element.parentNode) {
        this.element.parentNode.removeChild(this.element);
      }

      document.documentElement.style.removeProperty('--tg-announcement-bar-height');
    }

  }

  class FeatureColumnsSection {
    constructor(element) {
      var _this = this;

      this.element = element;
      this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
      Dom.nodeListToArray(this.element.querySelectorAll('.FeaturedColumnsCard')).forEach(function (item) {
        _this.intersectionObserver.observe(item);
      });
    }

    onUnload() {
      this.intersectionObserver.disconnect();
    }

    _reveal(results) {
      var _this = this;

      var toReveal = [];
      results.forEach(function (result) {
        if (result.isIntersecting || result.intersectionRatio > 0) {
          // isIntersecting does not exist on Samsung Android browser
          toReveal.push(result.target);

          _this.intersectionObserver.unobserve(result.target);
        }
      });

      if (toReveal.length === 0) {
        return;
      }

      themegoal.libs.anime({
        targets: toReveal,
        opacity: [0, 1],
        translateY: [30, 0],
        duration: 500,
        easing: 'cubicBezier(.5, .05, .1, .3)',
        delay: themegoal.libs.anime.stagger(300)
      });
    }

  }

  class LoginSection {
    constructor(container) {
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.customerLoginForm = this.element.querySelector('#CustomerLogin');
      this.recoverCustomerPasswordForm = this.element.querySelector('#RecoverCustomerPassword');
      this.delegateElement.on('click', '[data-action="toggle-customer-form"]', this._toggleCustomerForm.bind(this));
    }

    _toggleCustomerForm() {
      var isLoginActive = this.customerLoginForm.style.display === 'block';
      this.timeline = themegoal.libs.anime.timeline({
        easing: 'cubicBezier(.5, .05, .1, .3)',
        duration: 300
      });

      if (isLoginActive) {
        this.customerLoginForm.style.display = 'none';
        this.recoverCustomerPasswordForm.style.display = 'block';
        this.recoverCustomerPasswordForm.style.opacity = 0;
        this.timeline.add({
          targets: this.customerLoginForm,
          opacity: [1, 0],
          translateY: [0, 30]
        }).add({
          targets: this.recoverCustomerPasswordForm,
          opacity: [0, 1],
          translateY: [30, 0]
        });
      } else {
        this.customerLoginForm.style.display = 'block';
        this.recoverCustomerPasswordForm.style.display = 'none';
        this.customerLoginForm.style.opacity = 0;
        this.timeline.add({
          targets: this.recoverCustomerPasswordForm,
          opacity: [1, 0],
          translateY: [0, 30]
        }).add({
          targets: this.customerLoginForm,
          opacity: [0, 1],
          translateY: [30, 0]
        });
      }
    }

  }

  class ProductRecommendationsSection {
    constructor(container) {
      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (Shopify.designMode) {
        setTimeout(this._loadRecommendations.bind(this), 1000);
      } else {
        this._loadRecommendations();
      }
    }

    onUnload() {
      if (this.carousel) {
        this.carousel.destroy();
      }
    }

    _loadRecommendations() {
      var _this = this;

      var url = window.routes.productRecommendationsUrl + '?section_id=' + this.options['sectionId'] + '&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsCount'] + '&intent=' + this.options['recommendationsType'];
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content; //has recommend product

          if (container.querySelector('.ProductList--hasProduct')) {
            _this.element.querySelector('.ProductRecommendations__Body').innerHTML = container.querySelector('.ProductRecommendations__Body').innerHTML;

            if (_this.options['layout'] === 'carousel') {
              _this.carousel = new Carousel(_this.element.querySelector('[data-flickity-config]'));
            }
          } else {
            // Show the section
            _this.element.style.display = 'none';
          }
        });
      });
    }

  }

  class ProductRecentlyViewedSection {
    constructor(container) {
      this.element = container;
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (this.options['productId']) {
        this._saveProduct(this.options['productId']);
      }

      if (Shopify.designMode) {
        setTimeout(this._fetchProducts.bind(this), 1000);
      } else {
        this._fetchProducts();
      }
    }

    onUnload() {
      if (this.carousel) {
        this.carousel.destroy();
      }
    }

    _saveProduct(productId) {
      var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // We check if the current product already exists, and if it does not, we add it at the start

      if (!items.includes(productId)) {
        items.unshift(productId);
      } // Then, we save the current product into the local storage, by keeping only the this.options['viewedCount'] most recent


      try {
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, this.options['viewedCount'])));
      } catch (error) {// Do nothing, this may happen in Safari in incognito mode
      }
    }

    _fetchProducts() {
      var _this = this;

      var queryString = this._getSearchQueryString();

      if (queryString === '') {
        return;
      } // If we have a non empty query string we do a search query


      fetch(window.routes.searchUrl + '?section_id=' + this.options['sectionId'] + '&type=product&q=' + queryString, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = document.createElement('div');
          tempElement.innerHTML = content; // Set the content

          _this.element.querySelector('.ProductRecentlyViewed__Body').innerHTML = tempElement.querySelector('.ProductRecentlyViewed__Body').innerHTML; // Show the section

          _this.element.parentNode.style.display = 'block';

          if (_this.options['layout'] === 'carousel') {
            // And finally let's create the carousel !
            _this.carousel = new Carousel(_this.element.querySelector('[data-flickity-config]'));
          }
        });
      });
    }

    _getSearchQueryString() {
      var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]'); // If we are on a product template, we make sure to remove the main product from the related product

      if (items.includes(this.options['productId'])) {
        items.splice(items.indexOf(this.options['productId']), 1);
      }

      return items.map(function (item) {
        return 'id:' + item;
      }).join(' OR ');
    }

  }

  //点击product card的color swatch修改card的图片
  class ProductCardColorSwatch {
    constructor() {
      this.element = document.body;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.delegateElement.on('change', '.ProductCard__ColorSwatchRadio', this._colorChanged.bind(this));
    }

    _colorChanged(event, target) {
      // We need to change the URL of the various links, and various id
      let productItem = target.closest('.ProductCard'),
          variantUrl = target.getAttribute('data-variant-url');
      productItem.querySelector('.ProductCard__ImageWrapper > a').setAttribute('href', variantUrl);
      productItem.querySelector('.ProductCard__Title > a').setAttribute('href', variantUrl); // If we have a custom image for the variant, we change it

      var originalImageElement = productItem.querySelector('.ProductCard__Image:not(.ProductCard__Image--alternate)');

      if (target.hasAttribute('data-image-url') && target.getAttribute('data-image-id') !== originalImageElement.getAttribute('data-image-id')) {
        var newImageElement = document.createElement('img');
        newImageElement.className = 'ProductCard__Image';
        newImageElement.setAttribute('data-image-id', target.getAttribute('data-image-id'));
        newImageElement.setAttribute('src', target.getAttribute('data-image-url'));
        newImageElement.setAttribute('srcset', target.getAttribute('data-image-srcset')); // Replace the original node

        if (window.theme.productImageSize === 'natural') {
          originalImageElement.parentNode.style.setProperty('--tg-aspect-ratio', target.getAttribute('data-image-aspect-ratio'));
        }

        originalImageElement.parentNode.replaceChild(newImageElement, originalImageElement);
      }
    }

  }

  class FilterProducts {
    constructor(element) {
      this.element = element;
      this.delegateElement = new themegoal.libs.Delegate(this.element); //replace conent, layout switch srcoll

      this.filterProductsElement = this.element.querySelector('.FilterProducts');
      this.filterProductsContentElement = this.element.querySelector('.FilterProducts__Content');
      this.settings = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.currentSortBy = this.settings['sortBy']; // Setup product item color swatch

      new ProductCardColorSwatch(); // Setup animation

      this._setupAnimation();

      this._initPriceRangeAsideSlider();

      this._initPriceRangeDrawerSlider();

      this._bindEventsListeners();
    }

    _debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    _bindEventsListeners() {
      this._onInputListener = this._debounce(this._toggleFilter.bind(this), 500);
      this.delegateElement.on('click', '[data-tg-action="change-sort"]', this._sortByChanged.bind(this));
      this.delegateElement.on('click', '.FilterProducts__Form .ProductFilters__Item', this._onInputListener);
      this.delegateElement.on('click', '[data-tg-action="apply-price"]', this._onInputListener); //price toogle by button, not input
      //The popstate event of the Window interface is fired when the active history entry changes while the user navigates the session history

      window.addEventListener('popstate', function (event) {
        if (event.state.path) {
          window.location.href = event.state.path;
        }
      });
    }

    onUnload() {
      this.delegateElement.off('click');

      if (this.filterInnerSidebarScroller) {
        this.filterInnerSidebarScroller.destroy();
      }

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    _setupAnimation() {
      var _this = this; //_setupAnimation(true),ajax 


      var forceLoadFromTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false; // If there is already an observer set up, we remove it first

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      } //ajax loaded


      if (forceLoadFromTop) {
        themegoal.libs.anime({
          targets: this.filterProductsContentElement.querySelectorAll('.ProductCard'),
          opacity: [0, 1],
          translateY: [30, 0],
          duration: 500,
          easing: 'cubicBezier(.5, .05, .1, .3)',
          delay: themegoal.libs.anime.stagger(300)
        });
      } else {
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this), {
          threshold: 0.3
        });
        Dom.nodeListToArray(this.filterProductsContentElement.querySelectorAll('.ProductCard')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }

    _reveal(results) {
      var _this = this;

      var toReveal = [];
      results.forEach(function (result) {
        if (result.isIntersecting || result.intersectionRatio > 0) {
          // isIntersecting does not exist on Samsung Android browser
          toReveal.push(result.target);

          _this.intersectionObserver.unobserve(result.target);
        }
      });

      if (toReveal.length === 0) {
        return;
      }

      themegoal.libs.anime({
        targets: toReveal,
        opacity: [0, 1],
        translateY: [30, 0],
        duration: 500,
        easing: 'cubicBezier(.5, .05, .1, .3)',
        delay: themegoal.libs.anime.stagger(300)
      });
    }

    _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    _sortByChanged(event, target) {
      let sortBy = target.getAttribute("data-value");

      if (this.currentSortBy === sortBy) {
        return;
      }

      let eleP = target.closest('ul');
      let eles = eleP.querySelectorAll("li");
      eles.forEach(function (item) {
        item.classList.remove("Active");
      }); // target.classList.add("Active");// toogleFilter will removed again

      this.currentSortBy = sortBy;

      this._toggleFilter(event, target);
    }

    _toggleFilter(event, target) {
      let filterFrom = target.getAttribute("data-filter-from");

      if (target.classList.contains("Active")) {
        target.classList.remove("Active");
      } else {
        target.classList.add("Active");
      }

      let formData;

      if (filterFrom != undefined && filterFrom == 'aside') {
        formData = new FormData(this.element.querySelector('.FilterProducts__Form--aside'));
      } else {
        formData = new FormData(this.element.querySelector('.FilterProducts__Form--drawer'));
      }

      const searchParams = new URLSearchParams(formData).toString();

      this._reloadProducts(searchParams, filterFrom);
    }

    _reloadProducts(searchParams, filterFrom) {
      let _this = this;

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      var newUrl = window.location.protocol + '//' + window.location.host + this.settings['url'] + '?sort_by=' + this.currentSortBy + '&options[prefix]=last&' + searchParams; // We also rewrite the URL if browser supports it

      if (history.replaceState) {
        window.history.pushState({
          path: newUrl
        }, '', newUrl);
      }

      fetch(newUrl, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        response.text().then(function (content) {
          var tempElement = document.createElement('div');
          tempElement.innerHTML = content;
          _this.filterProductsContentElement.innerHTML = tempElement.querySelector('.FilterProducts__Content').innerHTML;
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          let itemsCountElement = tempElement.querySelector('.CollectionToolBar__ResultCount');

          if (itemsCountElement) {
            let itemsCountNumber = itemsCountElement.getAttribute("data-items-count");

            let targetCountEle = _this.element.querySelector(".CollectionAside__ProductCount strong");

            if (targetCountEle && itemsCountNumber) {
              targetCountEle.innerHTML = itemsCountNumber;
            }
          }

          let itemCounts = tempElement.querySelectorAll(".ProductFilters__ItemCount");
          itemCounts.forEach(function (item) {
            let itemCountId = item.getAttribute("id");
            _this.element.querySelector("#" + itemCountId).innerHTML = item.innerHTML;
          });

          _this._setupAnimation(true); // We scroll to the top 


          var elementOffset = _this.filterProductsElement.getBoundingClientRect().top - parseInt(document.documentElement.style.getPropertyValue('--tg-header-height')) - parseInt(document.documentElement.style.getPropertyValue('--tg-announcement-bar-height'));

          if (elementOffset < 0) {
            window.scrollBy({
              top: elementOffset,
              behavior: 'smooth'
            });
          }
        });
      });
    }

    _initPriceRangeAsideSlider() {
      let drawerPriceSlider = document.getElementById('Aside-Price-Slider');

      if (!(window.noUiSlider && drawerPriceSlider)) {
        return;
      }

      let maxRangeValue = drawerPriceSlider.getAttribute("data-tg-max-price");
      let drawerPriceMin = document.getElementById('Filter-Aside-Min-Price');
      let drawerPriceMax = document.getElementById('Filter-Aside-Max-Price');
      drawerPriceMin.setAttribute("readonly", "true");
      drawerPriceMax.setAttribute("readonly", "true");
      let handleMin = 0;
      let handleMax = parseFloat(maxRangeValue);

      if (drawerPriceMin.value != "") {
        handleMin = parseFloat(drawerPriceMin.value);
      }

      if (drawerPriceMax.value != "") {
        handleMax = parseFloat(drawerPriceMax.value);
      }

      noUiSlider.create(drawerPriceSlider, {
        start: [handleMin, handleMax],
        tooltips: [true, true],
        connect: true,
        range: {
          'min': 0,
          'max': parseFloat(maxRangeValue)
        }
      });
      drawerPriceSlider.noUiSlider.on('update', function (values, handle) {
        if (handle == 0) {
          drawerPriceMin.value = values[handle];
        }

        if (handle == 1) {
          drawerPriceMax.value = values[handle];
        }
      });
    }

    _initPriceRangeDrawerSlider() {
      let drawerPriceSlider = document.getElementById('Drawer-Price-Slider');

      if (!(window.noUiSlider && drawerPriceSlider)) {
        return;
      }

      let maxRangeValue = drawerPriceSlider.getAttribute("data-tg-max-price");
      let drawerPriceMin = document.getElementById('Filter-Drawer-Min-Price');
      let drawerPriceMax = document.getElementById('Filter-Drawer-Max-Price');
      drawerPriceMin.setAttribute("readonly", "true");
      drawerPriceMax.setAttribute("readonly", "true");
      let handleMin = 0;
      let handleMax = parseFloat(maxRangeValue);

      if (drawerPriceMin.value != "") {
        handleMin = parseFloat(drawerPriceMin.value);
      }

      if (drawerPriceMax.value != "") {
        handleMax = parseFloat(drawerPriceMax.value);
      }

      noUiSlider.create(drawerPriceSlider, {
        start: [handleMin, handleMax],
        tooltips: [true, true],
        connect: true,
        range: {
          'min': 0,
          'max': parseFloat(maxRangeValue)
        }
      });
      drawerPriceSlider.noUiSlider.on('update', function (values, handle) {
        if (handle == 0) {
          drawerPriceMin.value = values[handle];
        }

        if (handle == 1) {
          drawerPriceMax.value = values[handle];
        }
      });
    }

  }

  class CollectionSection {
    constructor(element) {
      this.element = element;
      new FilterProducts(this.element);
    }

  }

  class SearchSection {
    constructor(container) {
      this.element = container; // this.delegateElement = new themegoal.libs.Delegate(this.element);

      new FilterProducts(this.element); // this._setupAnimation();
    }

  }

  class Form {
    static serialize(form) {
      function stringKey(key, value) {
        var beginBracket = key.lastIndexOf('[');

        if (beginBracket === -1) {
          var _hash = {};
          _hash[key] = value;
          return _hash;
        }

        var newKey = key.substr(0, beginBracket);
        var newValue = {};
        newValue[key.substring(beginBracket + 1, key.length - 1)] = value;
        return stringKey(newKey, newValue);
      }

      var hash = {};

      for (var i = 0, len = form.elements.length; i < len; i++) {
        var formElement = form.elements[i];

        if (formElement.name === '' || formElement.disabled) {
          continue;
        }

        if (formElement.name && !formElement.disabled && (formElement.checked || /select|textarea/i.test(formElement.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(formElement.type))) {
          var stringKeys = stringKey(formElement.name, formElement.value);
          hash = Form.extend(hash, stringKeys);
        }
      }

      return hash;
    }

    static extend() {
      var extended = {};
      var i = 0; // Merge the object into the extended object

      var merge = function merge(obj) {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            // If property is an object, merge properties
            if (Object.prototype.toString.call(obj[prop]) === '[object Object]') {
              extended[prop] = Form.extend(extended[prop], obj[prop]);
            } else {
              extended[prop] = obj[prop];
            }
          }
        }
      }; // Loop through each object and conduct a merge


      for (; i < arguments.length; i++) {
        merge(arguments[i]);
      }

      return extended;
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  const MILLISECONDS_MULTIPLIER = 1000;
  const TRANSITION_END = 'transitionend'; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

  const toType = obj => {
    if (obj === null || obj === undefined) {
      return `${obj}`;
    }

    return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
  };

  const getSelector = element => {
    let selector = element.getAttribute('data-tg-target');

    if (!selector || selector === '#') {
      let hrefAttr = element.getAttribute('href'); // The only valid content that could double as a selector are IDs or classes,
      // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
      // `document.querySelector` will rightfully complain it is invalid.
      // See https://github.com/twbs/bootstrap/issues/32273

      if (!hrefAttr || !hrefAttr.includes('#') && !hrefAttr.startsWith('.')) {
        return null;
      } // Just in case some CMS puts out a full URL with the anchor appended


      if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
        hrefAttr = `#${hrefAttr.split('#')[1]}`;
      }

      selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null;
    }

    return selector;
  };

  const getSelectorFromElement = element => {
    const selector = getSelector(element);

    if (selector) {
      return document.querySelector(selector) ? selector : null;
    }

    return null;
  };

  const getElementFromSelector = element => {
    const selector = getSelector(element);
    return selector ? document.querySelector(selector) : null;
  };

  const getTransitionDurationFromElement = element => {
    if (!element) {
      return 0;
    } // Get transition-duration of the element


    let {
      transitionDuration,
      transitionDelay
    } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

    if (!floatTransitionDuration && !floatTransitionDelay) {
      return 0;
    } // If multiple durations are defined, take the first


    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
  };

  const triggerTransitionEnd = element => {
    element.dispatchEvent(new Event(TRANSITION_END));
  };

  const isElement = obj => {
    if (!obj || typeof obj !== 'object') {
      return false;
    }

    if (typeof obj.jquery !== 'undefined') {
      obj = obj[0];
    }

    return typeof obj.nodeType !== 'undefined';
  };

  const getElement = obj => {
    if (isElement(obj)) {
      // it's a jQuery object or a node element
      return obj.jquery ? obj[0] : obj;
    }

    if (typeof obj === 'string' && obj.length > 0) {
      return document.querySelector(obj);
    }

    return null;
  };

  const typeCheckConfig = (componentName, config, configTypes) => {
    Object.keys(configTypes).forEach(property => {
      const expectedTypes = configTypes[property];
      const value = config[property];
      const valueType = value && isElement(value) ? 'element' : toType(value);

      if (!new RegExp(expectedTypes).test(valueType)) {
        throw new TypeError(`${componentName.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
      }
    });
  };

  const isVisible = element => {
    if (!isElement(element) || element.getClientRects().length === 0) {
      return false;
    }

    return getComputedStyle(element).getPropertyValue('visibility') === 'visible';
  };

  const isDisabled = element => {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) {
      return true;
    }

    if (element.classList.contains('disabled')) {
      return true;
    }

    if (typeof element.disabled !== 'undefined') {
      return element.disabled;
    }

    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
  };

  const noop = () => {};
  /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */


  const reflow = element => {
    // eslint-disable-next-line no-unused-expressions
    element.offsetHeight;
  };

  const getjQuery = () => {
    const {
      jQuery
    } = window;

    if (jQuery && !document.body.hasAttribute('data-tg-no-jquery')) {
      return jQuery;
    }

    return null;
  };

  const isRTL = () => document.documentElement.dir === 'rtl';

  const execute = callback => {
    if (typeof callback === 'function') {
      callback();
    }
  };

  const executeAfterTransition = (callback, transitionElement, waitForTransition = true) => {
    if (!waitForTransition) {
      execute(callback);
      return;
    }

    const durationPadding = 5;
    const emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;

    const handler = ({
      target
    }) => {
      if (target !== transitionElement) {
        return;
      }

      called = true;
      transitionElement.removeEventListener(TRANSITION_END, handler);
      execute(callback);
    };

    transitionElement.addEventListener(TRANSITION_END, handler);
    setTimeout(() => {
      if (!called) {
        triggerTransitionEnd(transitionElement);
      }
    }, emulatedDuration);
  };
  /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */


  const getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed) => {
    let index = list.indexOf(activeElement); // if the element does not exist in the list return an element depending on the direction and if cycle is allowed

    if (index === -1) {
      return list[!shouldGetNext && isCycleAllowed ? list.length - 1 : 0];
    }

    const listLength = list.length;
    index += shouldGetNext ? 1 : -1;

    if (isCycleAllowed) {
      index = (index + listLength) % listLength;
    }

    return list[Math.max(0, Math.min(index, listLength - 1))];
  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  const NODE_TEXT = 3;
  const SelectorEngine = {
    find(selector, element = document.documentElement) {
      return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },

    findOne(selector, element = document.documentElement) {
      return Element.prototype.querySelector.call(element, selector);
    },

    children(element, selector) {
      return [].concat(...element.children).filter(child => child.matches(selector));
    },

    parents(element, selector) {
      const parents = [];
      let ancestor = element.parentNode;

      while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT) {
        if (ancestor.matches(selector)) {
          parents.push(ancestor);
        }

        ancestor = ancestor.parentNode;
      }

      return parents;
    },

    prev(element, selector) {
      let previous = element.previousElementSibling;

      while (previous) {
        if (previous.matches(selector)) {
          return [previous];
        }

        previous = previous.previousElementSibling;
      }

      return [];
    },

    next(element, selector) {
      let next = element.nextElementSibling;

      while (next) {
        if (next.matches(selector)) {
          return [next];
        }

        next = next.nextElementSibling;
      }

      return [];
    },

    focusableChildren(element) {
      const focusables = ['a', 'button', 'input', 'textarea', 'select', 'details', '[tabindex]', '[contenteditable="true"]'].map(selector => `${selector}:not([tabindex^="-"])`).join(', ');
      return this.find(focusables, element).filter(el => !isDisabled(el) && isVisible(el));
    }

  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  function normalizeData(val) {
    if (val === 'true') {
      return true;
    }

    if (val === 'false') {
      return false;
    }

    if (val === Number(val).toString()) {
      return Number(val);
    }

    if (val === '' || val === 'null') {
      return null;
    }

    return val;
  }

  function normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, chr => `-${chr.toLowerCase()}`);
  }

  const Manipulator = {
    setDataAttribute(element, key, value) {
      element.setAttribute(`data-tg-${normalizeDataKey(key)}`, value);
    },

    removeDataAttribute(element, key) {
      element.removeAttribute(`data-tg-${normalizeDataKey(key)}`);
    },

    getDataAttributes(element) {
      if (!element) {
        return {};
      }

      const attributes = {};
      Object.keys(element.dataset).filter(key => key.startsWith('tg')).forEach(key => {
        let pureKey = key.replace(/^tg/, '');
        pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
        attributes[pureKey] = normalizeData(element.dataset[key]);
      });
      return attributes;
    },

    getDataAttribute(element, key) {
      return normalizeData(element.getAttribute(`data-tg-${normalizeDataKey(key)}`));
    },

    offset(element) {
      const rect = element.getBoundingClientRect();
      return {
        top: rect.top + window.pageYOffset,
        left: rect.left + window.pageXOffset
      };
    },

    position(element) {
      return {
        top: element.offsetTop,
        left: element.offsetLeft
      };
    }

  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  const SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
  const SELECTOR_STICKY_CONTENT = '.sticky-top';

  class ScrollBarHelper {
    constructor() {
      this._element = document.body;
    }

    getWidth() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
      const documentWidth = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - documentWidth);
    }

    hide() {
      const width = this.getWidth();

      this._disableOverFlow(); // give padding to element to balance the hidden scrollbar width


      this._setElementAttributes(this._element, 'paddingRight', calculatedValue => calculatedValue + width); // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth


      this._setElementAttributes(SELECTOR_FIXED_CONTENT, 'paddingRight', calculatedValue => calculatedValue + width);

      this._setElementAttributes(SELECTOR_STICKY_CONTENT, 'marginRight', calculatedValue => calculatedValue - width);
    }

    _disableOverFlow() {
      this._saveInitialAttribute(this._element, 'overflow');

      this._element.style.overflow = 'hidden';
    }

    _setElementAttributes(selector, styleProp, callback) {
      const scrollbarWidth = this.getWidth();

      const manipulationCallBack = element => {
        if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) {
          return;
        }

        this._saveInitialAttribute(element, styleProp);

        const calculatedValue = window.getComputedStyle(element)[styleProp];
        element.style[styleProp] = `${callback(Number.parseFloat(calculatedValue))}px`;
      };

      this._applyManipulationCallback(selector, manipulationCallBack);
    }

    reset() {
      this._resetElementAttributes(this._element, 'overflow');

      this._resetElementAttributes(this._element, 'paddingRight');

      this._resetElementAttributes(SELECTOR_FIXED_CONTENT, 'paddingRight');

      this._resetElementAttributes(SELECTOR_STICKY_CONTENT, 'marginRight');
    }

    _saveInitialAttribute(element, styleProp) {
      const actualValue = element.style[styleProp];

      if (actualValue) {
        Manipulator.setDataAttribute(element, styleProp, actualValue);
      }
    }

    _resetElementAttributes(selector, styleProp) {
      const manipulationCallBack = element => {
        const value = Manipulator.getDataAttribute(element, styleProp);

        if (typeof value === 'undefined') {
          element.style.removeProperty(styleProp);
        } else {
          Manipulator.removeDataAttribute(element, styleProp);
          element.style[styleProp] = value;
        }
      };

      this._applyManipulationCallback(selector, manipulationCallBack);
    }

    _applyManipulationCallback(selector, callBack) {
      if (isElement(selector)) {
        callBack(selector);
      } else {
        SelectorEngine.find(selector, this._element).forEach(callBack);
      }
    }

    isOverflowing() {
      return this.getWidth() > 0;
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const namespaceRegex = /[^.]*(?=\..*)\.|.*/;
  const stripNameRegex = /\..*/;
  const stripUidRegex = /::\d+$/;
  const eventRegistry = {}; // Events storage

  let uidEvent = 1;
  const customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
  };
  const customEventsRegex = /^(mouseenter|mouseleave)/i;
  const nativeEvents = new Set(['click', 'dblclick', 'mouseup', 'mousedown', 'contextmenu', 'mousewheel', 'DOMMouseScroll', 'mouseover', 'mouseout', 'mousemove', 'selectstart', 'selectend', 'keydown', 'keypress', 'keyup', 'orientationchange', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel', 'gesturestart', 'gesturechange', 'gestureend', 'focus', 'blur', 'change', 'reset', 'select', 'submit', 'focusin', 'focusout', 'load', 'unload', 'beforeunload', 'resize', 'move', 'DOMContentLoaded', 'readystatechange', 'error', 'abort', 'scroll']);
  /**
   * ------------------------------------------------------------------------
   * Private methods
   * ------------------------------------------------------------------------
   */

  function getUidEvent(element, uid) {
    return uid && `${uid}::${uidEvent++}` || element.uidEvent || uidEvent++;
  }

  function getEvent(element) {
    const uid = getUidEvent(element);
    element.uidEvent = uid;
    eventRegistry[uid] = eventRegistry[uid] || {};
    return eventRegistry[uid];
  }

  function bootstrapHandler(element, fn) {
    return function handler(event) {
      event.delegateTarget = element;

      if (handler.oneOff) {
        EventHandler.off(element, event.type, fn);
      }

      return fn.apply(element, [event]);
    };
  }

  function bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
      const domElements = element.querySelectorAll(selector);

      for (let {
        target
      } = event; target && target !== this; target = target.parentNode) {
        for (let i = domElements.length; i--;) {
          if (domElements[i] === target) {
            event.delegateTarget = target;

            if (handler.oneOff) {
              EventHandler.off(element, event.type, selector, fn);
            }

            return fn.apply(target, [event]);
          }
        }
      } // To please ESLint


      return null;
    };
  }

  function findHandler(events, handler, delegationSelector = null) {
    const uidEventList = Object.keys(events);

    for (let i = 0, len = uidEventList.length; i < len; i++) {
      const event = events[uidEventList[i]];

      if (event.originalHandler === handler && event.delegationSelector === delegationSelector) {
        return event;
      }
    }

    return null;
  }

  function normalizeParams(originalTypeEvent, handler, delegationFn) {
    const delegation = typeof handler === 'string';
    const originalHandler = delegation ? delegationFn : handler;
    let typeEvent = getTypeEvent(originalTypeEvent);
    const isNative = nativeEvents.has(typeEvent);

    if (!isNative) {
      typeEvent = originalTypeEvent;
    }

    return [delegation, originalHandler, typeEvent];
  }

  function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) {
      return;
    }

    if (!handler) {
      handler = delegationFn;
      delegationFn = null;
    } // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does


    if (customEventsRegex.test(originalTypeEvent)) {
      const wrapFn = fn => {
        return function (event) {
          if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) {
            return fn.call(this, event);
          }
        };
      };

      if (delegationFn) {
        delegationFn = wrapFn(delegationFn);
      } else {
        handler = wrapFn(handler);
      }
    }

    const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
    const events = getEvent(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);

    if (previousFn) {
      previousFn.oneOff = previousFn.oneOff && oneOff;
      return;
    }

    const uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ''));
    const fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
    fn.delegationSelector = delegation ? handler : null;
    fn.originalHandler = originalHandler;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, delegation);
  }

  function removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = findHandler(events[typeEvent], handler, delegationSelector);

    if (!fn) {
      return;
    }

    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
  }

  function removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    Object.keys(storeElementEvent).forEach(handlerKey => {
      if (handlerKey.includes(namespace)) {
        const event = storeElementEvent[handlerKey];
        removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
      }
    });
  }

  function getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.tg.button' --> 'click')
    event = event.replace(stripNameRegex, '');
    return customEvents[event] || event;
  }

  const EventHandler = {
    on(element, event, handler, delegationFn) {
      addHandler(element, event, handler, delegationFn, false);
    },

    one(element, event, handler, delegationFn) {
      addHandler(element, event, handler, delegationFn, true);
    },

    off(element, originalTypeEvent, handler, delegationFn) {
      if (typeof originalTypeEvent !== 'string' || !element) {
        return;
      }

      const [delegation, originalHandler, typeEvent] = normalizeParams(originalTypeEvent, handler, delegationFn);
      const inNamespace = typeEvent !== originalTypeEvent;
      const events = getEvent(element);
      const isNamespace = originalTypeEvent.startsWith('.');

      if (typeof originalHandler !== 'undefined') {
        // Simplest case: handler is passed, remove that listener ONLY.
        if (!events || !events[typeEvent]) {
          return;
        }

        removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
        return;
      }

      if (isNamespace) {
        Object.keys(events).forEach(elementEvent => {
          removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        });
      }

      const storeElementEvent = events[typeEvent] || {};
      Object.keys(storeElementEvent).forEach(keyHandlers => {
        const handlerKey = keyHandlers.replace(stripUidRegex, '');

        if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
          const event = storeElementEvent[keyHandlers];
          removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
        }
      });
    },

    trigger(element, event, args) {
      if (typeof event !== 'string' || !element) {
        return null;
      }

      const $ = getjQuery();
      const typeEvent = getTypeEvent(event);
      const inNamespace = event !== typeEvent;
      const isNative = nativeEvents.has(typeEvent);
      let jQueryEvent;
      let bubbles = true;
      let nativeDispatch = true;
      let defaultPrevented = false;
      let evt = null;

      if (inNamespace && $) {
        jQueryEvent = $.Event(event, args);
        $(element).trigger(jQueryEvent);
        bubbles = !jQueryEvent.isPropagationStopped();
        nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
        defaultPrevented = jQueryEvent.isDefaultPrevented();
      }

      if (isNative) {
        evt = document.createEvent('HTMLEvents');
        evt.initEvent(typeEvent, bubbles, true);
      } else {
        evt = new CustomEvent(event, {
          bubbles,
          cancelable: true
        });
      } // merge custom information in our event


      if (typeof args !== 'undefined') {
        Object.keys(args).forEach(key => {
          Object.defineProperty(evt, key, {
            get() {
              return args[key];
            }

          });
        });
      }

      if (defaultPrevented) {
        evt.preventDefault();
      }

      if (nativeDispatch) {
        element.dispatchEvent(evt);
      }

      if (evt.defaultPrevented && typeof jQueryEvent !== 'undefined') {
        jQueryEvent.preventDefault();
      }

      return evt;
    }

  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  const elementMap = new Map();
  var Data = {
    set(element, key, instance) {
      if (!elementMap.has(element)) {
        elementMap.set(element, new Map());
      }

      const instanceMap = elementMap.get(element); // make it clear we only want one instance per element
      // can be removed later when multiple key/instances are fine to be used

      if (!instanceMap.has(key) && instanceMap.size !== 0) {
        // eslint-disable-next-line no-console
        console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
        return;
      }

      instanceMap.set(key, instance);
    },

    get(element, key) {
      if (elementMap.has(element)) {
        return elementMap.get(element).get(key) || null;
      }

      return null;
    },

    remove(element, key) {
      if (!elementMap.has(element)) {
        return;
      }

      const instanceMap = elementMap.get(element);
      instanceMap.delete(key); // free up element references if there are no instances left for an element

      if (instanceMap.size === 0) {
        elementMap.delete(element);
      }
    }

  };

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const VERSION = '5.1.1';

  class BaseComponent {
    constructor(element) {
      element = getElement(element);

      if (!element) {
        return;
      }

      this._element = element;
      Data.set(this._element, this.constructor.DATA_KEY, this);
    }

    dispose() {
      Data.remove(this._element, this.constructor.DATA_KEY);
      EventHandler.off(this._element, this.constructor.EVENT_KEY);
      Object.getOwnPropertyNames(this).forEach(propertyName => {
        this[propertyName] = null;
      });
    }

    _queueCallback(callback, element, isAnimated = true) {
      executeAfterTransition(callback, element, isAnimated);
    }
    /** Static */


    static getInstance(element) {
      return Data.get(getElement(element), this.DATA_KEY);
    }

    static getOrCreateInstance(element, config = {}) {
      return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }

    static get VERSION() {
      return VERSION;
    }

    static get NAME() {
      throw new Error('You have to implement the static method "NAME", for each component!');
    }

    static get DATA_KEY() {
      return `tg.${this.NAME}`;
    }

    static get EVENT_KEY() {
      return `.${this.DATA_KEY}`;
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */
  const Default$5 = {
    className: 'Modal__Backdrop',
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    isAnimated: false,
    rootElement: 'body',
    // give the choice to place backdrop under different elements
    clickCallback: null
  };
  const DefaultType$5 = {
    className: 'string',
    isVisible: 'boolean',
    isAnimated: 'boolean',
    rootElement: '(element|string)',
    clickCallback: '(function|null)'
  };
  const NAME$6 = 'backdrop';
  const CLASS_NAME_FADE$2 = 'Fade';
  const CLASS_NAME_SHOW$5 = 'Show';
  const EVENT_MOUSEDOWN = `mousedown.tg.${NAME$6}`;

  class Backdrop {
    constructor(config) {
      this._config = this._getConfig(config);
      this._isAppended = false;
      this._element = null;
    }

    show(callback) {
      if (!this._config.isVisible) {
        execute(callback);
        return;
      }

      this._append();

      if (this._config.isAnimated) {
        reflow(this._getElement());
      }

      this._getElement().classList.add(CLASS_NAME_SHOW$5);

      this._emulateAnimation(() => {
        execute(callback);
      });
    }

    hide(callback) {
      if (!this._config.isVisible) {
        execute(callback);
        return;
      }

      this._getElement().classList.remove(CLASS_NAME_SHOW$5);

      this._emulateAnimation(() => {
        this.dispose();
        execute(callback);
      });
    } // Private


    _getElement() {
      if (!this._element) {
        const backdrop = document.createElement('div');
        backdrop.className = this._config.className;

        if (this._config.isAnimated) {
          backdrop.classList.add(CLASS_NAME_FADE$2);
        }

        this._element = backdrop;
      }

      return this._element;
    }

    _getConfig(config) {
      config = { ...Default$5,
        ...(typeof config === 'object' ? config : {})
      }; // use getElement() with the default "body" to get a fresh Element on each instantiation

      config.rootElement = getElement(config.rootElement);
      typeCheckConfig(NAME$6, config, DefaultType$5);
      return config;
    }

    _append() {
      if (this._isAppended) {
        return;
      }

      this._config.rootElement.append(this._getElement());

      EventHandler.on(this._getElement(), EVENT_MOUSEDOWN, () => {
        execute(this._config.clickCallback);
      });
      this._isAppended = true;
    }

    dispose() {
      if (!this._isAppended) {
        return;
      }

      EventHandler.off(this._element, EVENT_MOUSEDOWN);

      this._element.remove();

      this._isAppended = false;
    }

    _emulateAnimation(callback) {
      executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
   * --------------------------------------------------------------------------
   */
  const Default$4 = {
    trapElement: null,
    // The element to trap focus inside of
    autofocus: true
  };
  const DefaultType$4 = {
    trapElement: 'element',
    autofocus: 'boolean'
  };
  const NAME$5 = 'focustrap';
  const DATA_KEY$5 = 'tg.focustrap';
  const EVENT_KEY$5 = `.${DATA_KEY$5}`;
  const EVENT_FOCUSIN = `focusin${EVENT_KEY$5}`;
  const EVENT_KEYDOWN_TAB = `keydown.tab${EVENT_KEY$5}`;
  const TAB_KEY$1 = 'Tab';
  const TAB_NAV_FORWARD = 'forward';
  const TAB_NAV_BACKWARD = 'backward';

  class FocusTrap {
    constructor(config) {
      this._config = this._getConfig(config);
      this._isActive = false;
      this._lastTabNavDirection = null;
    }

    activate() {
      const {
        trapElement,
        autofocus
      } = this._config;

      if (this._isActive) {
        return;
      }

      if (autofocus) {
        trapElement.focus();
      }

      EventHandler.off(document, EVENT_KEY$5); // guard against infinite focus loop

      EventHandler.on(document, EVENT_FOCUSIN, event => this._handleFocusin(event));
      EventHandler.on(document, EVENT_KEYDOWN_TAB, event => this._handleKeydown(event));
      this._isActive = true;
    }

    deactivate() {
      if (!this._isActive) {
        return;
      }

      this._isActive = false;
      EventHandler.off(document, EVENT_KEY$5);
    } // Private


    _handleFocusin(event) {
      const {
        target
      } = event;
      const {
        trapElement
      } = this._config;

      if (target === document || target === trapElement || trapElement.contains(target)) {
        return;
      }

      const elements = SelectorEngine.focusableChildren(trapElement);

      if (elements.length === 0) {
        trapElement.focus();
      } else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) {
        elements[elements.length - 1].focus();
      } else {
        elements[0].focus();
      }
    }

    _handleKeydown(event) {
      if (event.key !== TAB_KEY$1) {
        return;
      }

      this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
    }

    _getConfig(config) {
      config = { ...Default$4,
        ...(typeof config === 'object' ? config : {})
      };
      typeCheckConfig(NAME$5, config, DefaultType$4);
      return config;
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */

  const enableDismissTrigger = (component, method = 'hide') => {
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    EventHandler.on(document, clickEvent, `[data-tg-dismiss="${name}"]`, function (event) {
      if (['A', 'AREA'].includes(this.tagName)) {
        event.preventDefault();
      }

      if (isDisabled(this)) {
        return;
      }

      const target = getElementFromSelector(this) || this.closest(`.${name}`);
      const instance = component.getOrCreateInstance(target); // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method

      instance[method]();
    });
  };

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME$4 = 'Drawer';
  const DATA_KEY$4 = 'tg.Drawer';
  const EVENT_KEY$4 = `.${DATA_KEY$4}`;
  const DATA_API_KEY$4 = '.data-api';
  const EVENT_LOAD_DATA_API = `load${EVENT_KEY$4}${DATA_API_KEY$4}`;
  const ESCAPE_KEY$2 = 'Escape';
  const Default$3 = {
    backdrop: true,
    keyboard: true,
    scroll: false
  };
  const DefaultType$3 = {
    backdrop: 'boolean',
    keyboard: 'boolean',
    scroll: 'boolean'
  };
  const CLASS_NAME_SHOW$4 = 'Show';
  const CLASS_NAME_BACKDROP = 'Drawer__Backdrop';
  const OPEN_SELECTOR$1 = '.Drawer.Show';
  const EVENT_SHOW$4 = `show${EVENT_KEY$4}`;
  const EVENT_SHOWN$4 = `shown${EVENT_KEY$4}`;
  const EVENT_HIDE$4 = `hide${EVENT_KEY$4}`;
  const EVENT_HIDDEN$4 = `hidden${EVENT_KEY$4}`;
  const EVENT_CLICK_DATA_API$4 = `click${EVENT_KEY$4}${DATA_API_KEY$4}`;
  const EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${EVENT_KEY$4}`;
  const SELECTOR_DATA_TOGGLE$4 = '[data-tg-toggle="Drawer"]';
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class Drawer extends BaseComponent {
    constructor(element, config) {
      super(element);
      this._config = this._getConfig(config);
      this._isShown = false;
      this._backdrop = this._initializeBackDrop();
      this._focustrap = this._initializeFocusTrap();

      this._addEventListeners();
    } // Getters


    static get NAME() {
      return NAME$4;
    }

    static get Default() {
      return Default$3;
    } // Public


    toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    }

    show(relatedTarget) {
      if (this._isShown) {
        return;
      }

      const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, {
        relatedTarget
      });

      if (showEvent.defaultPrevented) {
        return;
      }

      this._isShown = true;
      this._element.style.visibility = 'visible';

      this._backdrop.show();

      if (!this._config.scroll) {
        new ScrollBarHelper().hide();
      }

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      this._element.setAttribute('role', 'dialog');

      this._element.classList.add(CLASS_NAME_SHOW$4);

      const completeCallBack = () => {
        if (!this._config.scroll) {
          this._focustrap.activate();
        }

        EventHandler.trigger(this._element, EVENT_SHOWN$4, {
          relatedTarget
        });
      };

      this._queueCallback(completeCallBack, this._element, true);
    }

    hide() {
      if (!this._isShown) {
        return;
      }

      const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4);

      if (hideEvent.defaultPrevented) {
        return;
      }

      this._focustrap.deactivate();

      this._element.blur();

      this._isShown = false;

      this._element.classList.remove(CLASS_NAME_SHOW$4);

      this._backdrop.hide();

      const completeCallback = () => {
        this._element.setAttribute('aria-hidden', true);

        this._element.removeAttribute('aria-modal');

        this._element.removeAttribute('role');

        this._element.style.visibility = 'hidden';

        if (!this._config.scroll) {
          new ScrollBarHelper().reset();
        }

        EventHandler.trigger(this._element, EVENT_HIDDEN$4);
      };

      this._queueCallback(completeCallback, this._element, true);
    }

    dispose() {
      this._backdrop.dispose();

      this._focustrap.deactivate();

      super.dispose();
    } // Private


    _getConfig(config) {
      config = { ...Default$3,
        ...Manipulator.getDataAttributes(this._element),
        ...(typeof config === 'object' ? config : {})
      };
      typeCheckConfig(NAME$4, config, DefaultType$3);
      return config;
    }

    _initializeBackDrop() {
      return new Backdrop({
        className: CLASS_NAME_BACKDROP,
        isVisible: this._config.backdrop,
        isAnimated: true,
        rootElement: this._element.parentNode,
        clickCallback: () => this.hide()
      });
    }

    _initializeFocusTrap() {
      return new FocusTrap({
        trapElement: this._element
      });
    }

    _addEventListeners() {
      EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, event => {
        if (this._config.keyboard && event.key === ESCAPE_KEY$2) {
          this.hide();
        }
      });
    }

  }
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function (event) {
    const target = getElementFromSelector(this);

    if (['A', 'AREA'].includes(this.tagName)) {
      event.preventDefault();
    }

    if (isDisabled(this)) {
      return;
    }

    EventHandler.one(target, EVENT_HIDDEN$4, () => {
      // focus on trigger when it is closed
      if (isVisible(this)) {
        this.focus();
      }
    }); // avoid conflict when clicking a toggler of an drawer, while another is open

    const allReadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);

    if (allReadyOpen && allReadyOpen !== target) {
      Drawer.getInstance(allReadyOpen).hide();
    }

    const data = Drawer.getOrCreateInstance(target);
    data.toggle(this);
  });
  EventHandler.on(window, EVENT_LOAD_DATA_API, () => SelectorEngine.find(OPEN_SELECTOR$1).forEach(el => Drawer.getOrCreateInstance(el).show()));
  enableDismissTrigger(Drawer);

  class ProductPickupAvailability {
    constructor(element, productTitle) {
      this.element = element;
      this.productTitle = productTitle;
    }

    updateWithVariant(variant) {
      if (!this.element) {
        return; // If the element to inject the store availability does not exist, we return immediately
      } // If the variant is null (for instance unavailable variant), we clear the container


      if (!variant) {
        this.element.textContent = '';
        return;
      } // If we have a new variant we render the section


      this._renderAvailabilitySection(variant['id']);
    }

    _renderAvailabilitySection(id) {
      let _this = this;

      this.element.innerHTML = ''; // If there is already an element with the given modal we remove it first

      var availabilityModal = document.getElementById('PickupAvailabilityModal-' + id);

      if (availabilityModal) {
        availabilityModal.remove();
      }

      return fetch(window.routes.rootUrlWithoutSlash + '/variants/' + id + '?section_id=pickup-availability').then(function (response) {
        return response.text().then(function (content) {
          _this.element.innerHTML = content;
          _this.element.innerHTML = _this.element.firstElementChild.innerHTML; // The product title is not rendered so we have to render it manually

          var productTitle = _this.element.querySelector('.Drawer__Title.Product__Title');

          if (productTitle) {
            productTitle.textContent = _this.productTitle;
          } // In order for our modal system to work we have to append the modal to the body instead


          let availabilityModal = document.getElementById('PickupAvailabilityModal-' + id);

          if (availabilityModal) {
            document.body.appendChild(availabilityModal); // Create the drawer

            new Drawer(availabilityModal);
          }
        });
      });
    }

  }

  class ProductVariants {
    constructor(container, options) {
      let _this = this;

      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = options;
      let jsonData = JSON.parse(this.element.querySelector('[data-product-json]').innerHTML);
      this.productData = jsonData['product'];
      this.variantsInventories = jsonData['inventories'] || {};
      this.sectionId = jsonData['section_id'];
      this.variantSelector = this.element.querySelector('#ProductSelect--' + this.sectionId);
      if (!this.productData['id']) return; // We init value with the first selected variant

      this.productData['variants'].forEach(function (variant) {
        if (variant['id'] === jsonData['selected_variant_id']) {
          _this.currentVariant = variant;
          _this.option1 = variant['option1'];
          _this.option2 = variant['option2'];
          _this.option3 = variant['option3'];
        }
      });
      this.pickupAvailability = new ProductPickupAvailability(this.element.querySelector('.Product__StoreAvailabilityContainer'), this.productData['title']);
      this.pickupAvailability.updateWithVariant(this.currentVariant);

      this._bindEventsListeners();
    }

    destroy() {
      this.delegateElement.off('click');
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '[data-action="add-to-cart"]', this._addToCart.bind(this));
      this.delegateElement.on('click', '[data-action="decrease-quantity"]', this._decreaseQuantity.bind(this));
      this.delegateElement.on('click', '[data-action="increase-quantity"]', this._increaseQuantity.bind(this));
      this.delegateElement.on('change', '.ProductForm__QuantityNum', this._validateQuantity.bind(this)); // Hook when a radio button change

      this.delegateElement.on('change', '.ProductForm__Option [type="radio"]', this._onOptionChanged.bind(this));
      this.delegateElement.on('keydown', '.ProductForm__Option [type="radio"]~label', this._labeEnerKeyEvent.bind(this));
      this.delegateElement.on('change', '.ProductForm__Option .Form__Select', this._onOptionChanged.bind(this));
      this.delegateElement.on('change', '.ProductForm__CustomProperty [type="radio"]', this._onChangeCustomPropertyRadio.bind(this));
      this.delegateElement.on('change', '.ProductForm__CustomProperty .Form__Select', this._onChangeCustomPropertySelect.bind(this));
      this.delegateElement.on('change', '.ProductForm__CustomProperty .Form__Input', this._onChangeCustomPropertyText.bind(this));
    }

    _labeEnerKeyEvent(event, target) {
      if (event.keyCode == 13) {
        let inputId = target.getAttribute("for");
        let inputElement = document.getElementById(inputId);
        inputElement.click();
      }
    }

    _onVariantChanged(previousVariant, newVariant) {
      this._updateProductInfo(newVariant); // update the add to cart button


      this._updateAddToCartButton(newVariant, previousVariant); // pick availability


      this.pickupAvailability.updateWithVariant(newVariant); // Finally, we send an event so that other system could hook and do their own logic

      this.element.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: newVariant,
          previousVariant: previousVariant
        }
      }));
    }

    _updateProductInfo(newVariant) {
      let _this = this;

      let destinationPriceList = _this.element.querySelector(".Product__PriceList");

      let destinationSKU = _this.element.querySelector(".Product__Sku");

      let destinationUnitPrice = _this.element.querySelector(".Product__UnitPrice");

      let destinationInventory = _this.element.querySelector('.ProductForm__Inventory');

      let destinationPayInstallments = _this.element.querySelector(".Product__PayInstallments");

      if (!newVariant) {
        if (destinationPriceList) destinationPriceList.innerHTML = "";
        if (destinationSKU) destinationSKU.innerHTML = "";
        if (destinationUnitPrice) destinationUnitPrice.innerHTML = "";
        if (destinationInventory) destinationInventory.innerHTML = "";
        if (destinationPayInstallments) destinationPayInstallments.innerHTML = "";
        return;
      }

      fetch(window.routes.rootUrlWithoutSlash + '/variants/' + newVariant['id'] + '?section_id=product-info').then(function (response) {
        return response.text().then(function (content) {
          const html = new DOMParser().parseFromString(content, 'text/html');
          const sourcePriceList = html.querySelector(".Product__PriceList");
          if (sourcePriceList && destinationPriceList) destinationPriceList.innerHTML = sourcePriceList.innerHTML;

          if (_this.options['showSku']) {
            const sourceSKU = html.querySelector(".Product__Sku");

            if (sourceSKU && destinationSKU) {
              destinationSKU.innerHTML = sourceSKU.innerHTML;
              destinationSKU.style.display = sourceSKU.style.display;
            }
          }

          const sourceUnitPrice = html.querySelector(".Product__UnitPrice");

          if (sourceUnitPrice && destinationUnitPrice) {
            destinationUnitPrice.innerHTML = sourceUnitPrice.innerHTML;
            destinationUnitPrice.style.display = sourceUnitPrice.style.display;
          }

          if (_this.options['showInventoryQuantity']) {
            let variantInventory = newVariant ? _this.variantsInventories[newVariant['id']] : null;

            if (destinationInventory && variantInventory) {
              if (null === newVariant['inventory_management'] || variantInventory['inventory_quantity'] <= 0 || _this.options['inventoryQuantityThreshold'] > 0 && variantInventory['inventory_quantity'] > _this.options['inventoryQuantityThreshold']) {
                destinationInventory.style.display = 'none';
              } else {
                const sourceInventory = html.querySelector(".ProductForm__Inventory");

                if (sourceInventory) {
                  destinationInventory.innerHTML = sourceInventory.innerHTML;
                  destinationInventory.style.display = '';
                }
              }
            }
          }

          const sourcePayInstallments = html.querySelector(".Product__PayInstallments");
          if (sourcePayInstallments && destinationPayInstallments) destinationPayInstallments.innerHTML = sourcePayInstallments.innerHTML;
        });
      });
    }

    _updateAddToCartButton(newVariant) {
      let addToCartButton = this.element.querySelector('.ProductForm__AddToCart'),
          shopifyPaymentButton = this.element.querySelector('.shopify-payment-button'),
          newButton = document.createElement('button');

      if (addToCartButton) {
        newButton.setAttribute('type', 'submit');
        newButton.className = 'ProductForm__AddToCart Button Button--full';

        if (!newVariant) {
          newButton.setAttribute('disabled', 'disabled');
          newButton.removeAttribute('data-action');
          newButton.classList.add('Button--outline');
          newButton.innerHTML = window.languages.productFormUnavailable;
        } else {
          if (newVariant['available']) {
            newButton.removeAttribute('disabled');
            newButton.classList.add(this.options['showPaymentButton'] ? 'Button--outline' : 'Button--primary');
            newButton.setAttribute('data-action', 'add-to-cart');
            newButton.innerHTML = '<span>' + window.languages.productFormAddToCart + '</span>';
          } else {
            newButton.setAttribute('disabled', 'disabled');
            newButton.classList.add('Button--outline');
            newButton.removeAttribute('data-action');
            newButton.innerHTML = window.languages.productFormSoldOut;
          }
        }

        if (this.options['showPaymentButton'] && shopifyPaymentButton) {
          if (!newVariant || !newVariant['available']) {
            shopifyPaymentButton.style.display = 'none';
          } else {
            shopifyPaymentButton.style.display = 'block';
          }
        } // We replace the HTML instead of editing as it prevents for the CSS transition to show up


        addToCartButton.parentNode.replaceChild(newButton, addToCartButton);
      }
    }

    _onChangeCustomPropertyRadio(event, target) {
      let selectedValue = target.closest('.ProductForm__CustomProperty').querySelector('.ProductForm__SelectedValue');
      let invalidFeedbackElment = target.closest('.ProductForm__CustomProperty').querySelector('.InvalidFeedback');

      if (selectedValue) {
        selectedValue.innerHTML = target.value;
      }

      if (invalidFeedbackElment) {
        invalidFeedbackElment.classList.add("Valided");
      }
    }

    _onChangeCustomPropertySelect(event, target) {
      let invalidFeedbackElment = target.closest('.ProductForm__CustomProperty').querySelector('.InvalidFeedback');

      if (invalidFeedbackElment) {
        if (target.value != "") {
          invalidFeedbackElment.classList.add("Valided");
        } else {
          invalidFeedbackElment.classList.remove("Valided");
        }
      }
    }

    _onChangeCustomPropertyText(event, target) {
      let invalidFeedbackElment = target.closest('.ProductForm__CustomProperty').querySelector('.InvalidFeedback');

      if (invalidFeedbackElment) {
        if (target.value != "") {
          invalidFeedbackElment.classList.add("Valided");
        } else {
          invalidFeedbackElment.classList.remove("Valided");
        }
      }
    }

    _onOptionChanged(event, target) {
      //block
      if (target.getAttribute('data-option-position')) {
        this['option' + target.getAttribute('data-option-position')] = target.value;
      } else {
        //select
        let selectedOption = target.options[target.selectedIndex];
        this['option' + selectedOption.getAttribute('data-option-position')] = target.value;
      } //label //closest 


      let selectedValue = target.closest('.ProductForm__Option').querySelector('.ProductForm__SelectedValue');

      if (selectedValue) {
        selectedValue.innerHTML = target.value;
      } // Finally, we get the new variant


      let previousVariant = this.currentVariant;
      this.currentVariant = this._getCurrentVariantFromOptions();

      this._onVariantChanged(previousVariant, this.currentVariant);

      if (this.currentVariant) {
        if (this.options['enableHistoryState']) {
          this._updateHistoryState(this.currentVariant);
        } // We need to modify the hidden select that contain the id attribute as well
        // change variant id


        if (this.variantSelector) {
          this.variantSelector.querySelector('[selected]').removeAttribute('selected');
          this.variantSelector.querySelector('[value="' + this.currentVariant['id'] + '"]').setAttribute('selected', 'selected');
        }
      }
    }

    _getCurrentVariantFromOptions() {
      let _this = this;

      let found = false;
      this.productData['variants'].forEach(function (variant) {
        if (variant['option1'] === _this.option1 && variant['option2'] === _this.option2 && variant['option3'] === _this.option3) {
          found = variant;
        }
      });
      return found || null;
    }

    _updateHistoryState(variant) {
      if (!history.replaceState) {
        return;
      }

      let newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
    }

    _addToCart(event) {
      let _this = this; // if (!this.options['useAjaxCart']) {
      //   return; // When using a cart type of page, we just simply redirect to the cart page
      // }


      event.preventDefault(); // Prevent form to be submitted

      let formElement = this.element.querySelector('form.ProductForm');

      if (!formElement.checkValidity()) {
        if (!this.element.classList.contains(".ProductFormValidated")) {
          this.element.classList.add('ProductFormValidated');
        }

        return;
      } else {
        this.element.classList.remove('ProductFormValidated');
      }

      let addToCartButton = this.element.querySelector('.ProductForm__AddToCart'); // First, we switch the status of the button

      addToCartButton.setAttribute('disabled', 'disabled');
      document.dispatchEvent(new CustomEvent('theme:loading:start')); // // Then we add the product in Ajax
      // let formElement = this.element.querySelector('form.ProductForm');

      fetch(window.routes.cartAddUrl + '.js', {
        body: JSON.stringify(Form.serialize(formElement)),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));

        if (response.ok) {
          if (!_this.options['useAjaxCart']) {
            window.location.href = window.routes.cartUrl; // return; // When using a cart type of page, we just simply redirect to the cart page
          } else {
            addToCartButton.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

            _this.element.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: {
                variant: _this.currentVariant,
                quantity: parseInt(_this.element.querySelector('[name="quantity"]').value)
              }
            }));
          }
        } else {
          response.json().then(function (content) {
            var errorMessageElement = document.createElement('div');
            errorMessageElement.className = 'Alert Alert--danger';
            errorMessageElement.innerHTML = content['description'];
            addToCartButton.removeAttribute('disabled');
            addToCartButton.insertAdjacentElement('beforeBegin', errorMessageElement);
            setTimeout(function () {
              errorMessageElement.remove();
            }, 5000);
          });
        }
      });
      event.preventDefault();
    }

    _decreaseQuantity(event, target) {
      let qty = Math.max(parseInt(this.element.querySelector(".ProductForm__QuantityNum").value) - 1, 1);
      this.element.querySelector(".ProductForm__QuantityNum").value = qty;
      this.element.querySelector('[name="quantity"]').value = qty;
    }

    _increaseQuantity(event, target) {
      let qty = parseInt(this.element.querySelector(".ProductForm__QuantityNum").value) + 1;
      this.element.querySelector(".ProductForm__QuantityNum").value = qty;
      this.element.querySelector('[name="quantity"]').value = qty;
    }

    _validateQuantity(event, target) {
      target.value = Math.max(parseInt(target.value) || 1, 1);
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): modal.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME$3 = 'Modal';
  const DATA_KEY$3 = 'tg.Modal';
  const EVENT_KEY$3 = `.${DATA_KEY$3}`;
  const DATA_API_KEY$3 = '.data-api';
  const ESCAPE_KEY$1 = 'Escape';
  const Default$2 = {
    backdrop: true,
    keyboard: true,
    focus: true
  };
  const DefaultType$2 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    focus: 'boolean'
  };
  const EVENT_HIDE$3 = `hide${EVENT_KEY$3}`;
  const EVENT_HIDE_PREVENTED = `hidePrevented${EVENT_KEY$3}`;
  const EVENT_HIDDEN$3 = `hidden${EVENT_KEY$3}`;
  const EVENT_SHOW$3 = `show${EVENT_KEY$3}`;
  const EVENT_SHOWN$3 = `shown${EVENT_KEY$3}`;
  const EVENT_RESIZE = `resize${EVENT_KEY$3}`;
  const EVENT_CLICK_DISMISS = `click.dismiss${EVENT_KEY$3}`;
  const EVENT_KEYDOWN_DISMISS = `keydown.dismiss${EVENT_KEY$3}`;
  const EVENT_MOUSEUP_DISMISS = `mouseup.dismiss${EVENT_KEY$3}`;
  const EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${EVENT_KEY$3}`;
  const EVENT_CLICK_DATA_API$3 = `click${EVENT_KEY$3}${DATA_API_KEY$3}`;
  const CLASS_NAME_OPEN = 'Modal--open';
  const CLASS_NAME_FADE$1 = 'Fade';
  const CLASS_NAME_SHOW$3 = 'Show';
  const CLASS_NAME_STATIC = 'Modal--static';
  const OPEN_SELECTOR = '.Modal.Show';
  const SELECTOR_DIALOG = '.Modal__Dialog';
  const SELECTOR_MODAL_BODY = '.Modal__Body';
  const SELECTOR_DATA_TOGGLE$3 = '[data-tg-toggle="Modal"]';
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class Modal extends BaseComponent {
    constructor(element, config) {
      super(element);
      this._config = this._getConfig(config);
      this._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, this._element);
      this._backdrop = this._initializeBackDrop();
      this._focustrap = this._initializeFocusTrap();
      this._isShown = false;
      this._ignoreBackdropClick = false;
      this._isTransitioning = false;
      this._scrollBar = new ScrollBarHelper();
    } // Getters


    static get Default() {
      return Default$2;
    }

    static get NAME() {
      return NAME$3;
    } // Public


    toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    }

    show(relatedTarget) {
      if (this._isShown || this._isTransitioning) {
        return;
      }

      const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
        relatedTarget
      });

      if (showEvent.defaultPrevented) {
        return;
      }

      this._isShown = true;

      if (this._isAnimated()) {
        this._isTransitioning = true;
      }

      this._scrollBar.hide();

      document.body.classList.add(CLASS_NAME_OPEN);

      this._adjustDialog();

      this._setEscapeEvent();

      this._setResizeEvent();

      EventHandler.on(this._dialog, EVENT_MOUSEDOWN_DISMISS, () => {
        EventHandler.one(this._element, EVENT_MOUSEUP_DISMISS, event => {
          if (event.target === this._element) {
            this._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(() => this._showElement(relatedTarget));
    }

    hide() {
      if (!this._isShown || this._isTransitioning) {
        return;
      }

      const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);

      if (hideEvent.defaultPrevented) {
        return;
      }

      this._isShown = false;

      const isAnimated = this._isAnimated();

      if (isAnimated) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      this._focustrap.deactivate();

      this._element.classList.remove(CLASS_NAME_SHOW$3);

      EventHandler.off(this._element, EVENT_CLICK_DISMISS);
      EventHandler.off(this._dialog, EVENT_MOUSEDOWN_DISMISS);

      this._queueCallback(() => this._hideModal(), this._element, isAnimated);
    }

    dispose() {
      [window, this._dialog].forEach(htmlElement => EventHandler.off(htmlElement, EVENT_KEY$3));

      this._backdrop.dispose();

      this._focustrap.deactivate();

      super.dispose();
    }

    handleUpdate() {
      this._adjustDialog();
    } // Private


    _initializeBackDrop() {
      return new Backdrop({
        rootElement: this._element.parentNode,
        isVisible: Boolean(this._config.backdrop),
        // 'static' option will be translated to true, and booleans will keep their value
        isAnimated: this._isAnimated()
      });
    }

    _initializeFocusTrap() {
      return new FocusTrap({
        trapElement: this._element
      });
    }

    _getConfig(config) {
      config = { ...Default$2,
        ...Manipulator.getDataAttributes(this._element),
        ...(typeof config === 'object' ? config : {})
      };
      typeCheckConfig(NAME$3, config, DefaultType$2);
      return config;
    }

    _showElement(relatedTarget) {
      const isAnimated = this._isAnimated();

      const modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // Don't move modal's DOM position
        document.body.append(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      this._element.setAttribute('role', 'dialog');

      this._element.scrollTop = 0;

      if (modalBody) {
        modalBody.scrollTop = 0;
      }

      if (isAnimated) {
        reflow(this._element);
      }

      this._element.classList.add(CLASS_NAME_SHOW$3);

      const transitionComplete = () => {
        if (this._config.focus) {
          this._focustrap.activate();
        }

        this._isTransitioning = false;
        EventHandler.trigger(this._element, EVENT_SHOWN$3, {
          relatedTarget
        });
      };

      this._queueCallback(transitionComplete, this._dialog, isAnimated);
    }

    _setEscapeEvent() {
      if (this._isShown) {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, event => {
          if (this._config.keyboard && event.key === ESCAPE_KEY$1) {
            event.preventDefault();
            this.hide();
          } else if (!this._config.keyboard && event.key === ESCAPE_KEY$1) {
            this._triggerBackdropTransition();
          }
        });
      } else {
        EventHandler.off(this._element, EVENT_KEYDOWN_DISMISS);
      }
    }

    _setResizeEvent() {
      if (this._isShown) {
        EventHandler.on(window, EVENT_RESIZE, () => this._adjustDialog());
      } else {
        EventHandler.off(window, EVENT_RESIZE);
      }
    }

    _hideModal() {
      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._element.removeAttribute('aria-modal');

      this._element.removeAttribute('role');

      this._isTransitioning = false;

      this._backdrop.hide(() => {
        document.body.classList.remove(CLASS_NAME_OPEN);

        this._resetAdjustments();

        this._scrollBar.reset();

        EventHandler.trigger(this._element, EVENT_HIDDEN$3);
      });
    }

    _showBackdrop(callback) {
      EventHandler.on(this._element, EVENT_CLICK_DISMISS, event => {
        if (this._ignoreBackdropClick) {
          this._ignoreBackdropClick = false;
          return;
        }

        if (event.target !== event.currentTarget) {
          return;
        }

        if (this._config.backdrop === true) {
          this.hide();
        } else if (this._config.backdrop === 'static') {
          this._triggerBackdropTransition();
        }
      });

      this._backdrop.show(callback);
    }

    _isAnimated() {
      return this._element.classList.contains(CLASS_NAME_FADE$1);
    }

    _triggerBackdropTransition() {
      const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);

      if (hideEvent.defaultPrevented) {
        return;
      }

      const {
        classList,
        scrollHeight,
        style
      } = this._element;
      const isModalOverflowing = scrollHeight > document.documentElement.clientHeight; // return if the following background transition hasn't yet completed

      if (!isModalOverflowing && style.overflowY === 'hidden' || classList.contains(CLASS_NAME_STATIC)) {
        return;
      }

      if (!isModalOverflowing) {
        style.overflowY = 'hidden';
      }

      classList.add(CLASS_NAME_STATIC);

      this._queueCallback(() => {
        classList.remove(CLASS_NAME_STATIC);

        if (!isModalOverflowing) {
          this._queueCallback(() => {
            style.overflowY = '';
          }, this._dialog);
        }
      }, this._dialog);

      this._element.focus();
    } // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // ----------------------------------------------------------------------


    _adjustDialog() {
      const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      const scrollbarWidth = this._scrollBar.getWidth();

      const isBodyOverflowing = scrollbarWidth > 0;

      if (!isBodyOverflowing && isModalOverflowing && !isRTL() || isBodyOverflowing && !isModalOverflowing && isRTL()) {
        this._element.style.paddingLeft = `${scrollbarWidth}px`;
      }

      if (isBodyOverflowing && !isModalOverflowing && !isRTL() || !isBodyOverflowing && isModalOverflowing && isRTL()) {
        this._element.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    }

  }
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
    const target = getElementFromSelector(this);

    if (['A', 'AREA'].includes(this.tagName)) {
      event.preventDefault();
    }

    EventHandler.one(target, EVENT_SHOW$3, showEvent => {
      if (showEvent.defaultPrevented) {
        // only register focus restorer if modal will actually get shown
        return;
      }

      EventHandler.one(target, EVENT_HIDDEN$3, () => {
        if (isVisible(this)) {
          this.focus();
        }
      });
    }); // avoid conflict when clicking moddal toggler while another one is open

    const allReadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);

    if (allReadyOpen) {
      Modal.getInstance(allReadyOpen).hide();
    }

    const data = Modal.getOrCreateInstance(target);
    data.toggle(this);
  });
  enableDismissTrigger(Modal);

  class ProductImageModal {
    constructor(element) {
      this.element = element;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.quiviewModalElement = document.getElementById('ProductMediaZoomModal');
      this.quiviewModal = null;
      this.activeMedia = null;

      this._bindEventsListeners();
    }

    destroy() {
      this.delegateElement.off('click');
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '.MediaModalOpener', this._openMediaModal.bind(this), true);
      this.quiviewModalElement.addEventListener('hidden.tg.Modal', function (event) {
        window.pauseAllMedia();
      });

      let _this = this;

      this.quiviewModalElement.addEventListener('shown.tg.Modal', function (event) {
        window.pauseAllMedia();

        _this.activeMedia.scrollIntoView({
          behavior: 'smooth',
          block: "start"
        });
      });
    }

    _openMediaModal(event, target) {
      let imageBreakpoint = Responsive.getCurrentBreakpoint();

      if (imageBreakpoint == "small") {
        event.stopImmediatePropagation();

        this._setActiveMeida(target);

        this.quiviewModal = new Modal(this.quiviewModalElement);
        this.quiviewModal.show();
      } else {
        if (target.classList.contains("MediaModalOpener--image")) {
          this._setActiveMeida(target);

          this.quiviewModal = new Modal(this.quiviewModalElement);
          this.quiviewModal.show();
        }
      }
    }

    _setActiveMeida(target) {
      let openers = this.quiviewModalElement.querySelectorAll(".Product__MediaWrapper");
      let currentMediaId = target.getAttribute("data-media-id");

      if (openers) {
        openers.forEach(function (item) {
          item.classList.remove("Active");
        });
        this.activeMedia = this.quiviewModalElement.querySelector('[data-media-id="' + currentMediaId + '"]');

        if (this.activeMedia) {
          this.activeMedia.classList.add("Active");
        }
      }
    }

  }

  class ProductSection {
    constructor(container) {

      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.productVariants = new ProductVariants(container, this.options);

      this._initStackGalleryCurrentImageStatus();

      let productSlideshowElement = this.element.querySelector('.ProductGallery__Carousel');
      let productSlideshowNavElement = this.element.querySelector('.ProductGallery__Thumbs');

      if (productSlideshowElement) {
        this.productSlideshow = new Carousel(productSlideshowElement);
      }

      if (productSlideshowNavElement) {
        new Carousel(productSlideshowNavElement);
      }

      if (this.options['enableImageZoom']) {
        this.imageZoomInstance = new ProductImageModal(this.element);
      }

      let styleWithCarouselEle = this.element.querySelectorAll(".ProductStyleWith__Body .ProductList--carousel");

      if (styleWithCarouselEle) {
        styleWithCarouselEle.forEach(function (ele) {
          new Carousel(ele);
        });
      }

      let offscreenElement = this.element.querySelector('.Site__TopLevelElment');

      if (offscreenElement) {
        document.body.appendChild(offscreenElement);
      }

      this.blockRecommendationsElementRelated = this.element.querySelector('.ProductBlockRecommendations--related');

      if (this.blockRecommendationsElementRelated) {
        this._loadRecommendations();
      }

      this.blockRecommendationsElementComplementary = this.element.querySelector('.ProductBlockRecommendations--complementary');

      if (this.blockRecommendationsElementComplementary) {
        this._loadRecommendationsComplementary();
      }

      this._bindEventsListeners();
    }

    onUnload() {}

    _bindEventsListeners() {
      this.delegateElement.on('variant:changed', this._updateSlideshowImage.bind(this));
    }

    _loadRecommendations() {
      var _this = this;

      var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=related&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsRelatedCount'];
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;

          let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--related .ProductBlockRecommendations__Body'); //has recommend product


          if (container.querySelector('.Carousel__Item')) {
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
            new Carousel(recommendationsElement.querySelector('[data-flickity-config]'));
          } else {
            // Show the section
            _this.blockRecommendationsElementRelated.style.display = 'none';
          }
        });
      });
    }

    _loadRecommendationsComplementary() {
      var _this = this;

      var url = window.routes.productRecommendationsUrl + '?section_id=product-block-recommendations&intent=complementary&product_id=' + this.options['productId'] + '&limit=' + this.options['recommendationsComplementaryCount'];
      return fetch(url).then(function (response) {
        return response.text().then(function (content) {
          var container = document.createElement('div');
          container.innerHTML = content;

          let recommendationsElement = _this.element.querySelector('.ProductBlockRecommendations--complementary .ProductBlockRecommendations__Body'); //has recommend product


          if (container.querySelector('.Carousel__Item')) {
            recommendationsElement.querySelector('.ProductList--carousel').innerHTML = container.querySelector(".ProductBlockRecommendations__Body").innerHTML;
            new Carousel(recommendationsElement.querySelector('[data-flickity-config]'));
          } else {
            // Show the section
            _this.blockRecommendationsElementComplementary.style.display = 'none';
          }
        });
      });
    }
    /**
     * Update the main carousel image
     */


    _updateSlideshowImage(event) {
      var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;

      if (!variant || !variant['featured_media'] || previousVariant && previousVariant['featured_media'] && previousVariant['featured_media']['id'] === variant['featured_media']['id']) {
        return;
      }

      if (this.options['galleryDesign'] == 'carousel') {
        for (var i = 0; i !== this.productSlideshow.flickityInstance.cells.length; ++i) {
          var cellElement = this.productSlideshow.flickityInstance.cells[i].element,
              mediaId = parseInt(cellElement.getAttribute('data-media-id'));

          if (mediaId === variant['featured_media']['id']) {
            this.productSlideshow.selectCell(parseInt(cellElement.getAttribute('data-media-position')) - 1);
          }
        }
      } else if (this.options['galleryDesign'] == 'stack_images') {
        let stackElement = this.element.querySelector(".ProductGallery--stack");

        if (stackElement) {
          let stackItems = stackElement.querySelectorAll('.Product__MediaWrapper');
          stackItems.forEach(function (item) {
            item.classList.remove("Product__MediaWrapper--currentVariantImage");
          });
          let stackItem = stackElement.querySelector('[data-media-id="' + variant['featured_media']['id'] + '"]');
          stackItem.classList.add("Product__MediaWrapper--currentVariantImage");
          stackItem.scrollIntoView({
            behavior: 'smooth',
            block: "start"
          });
        }
      }
    }

    _initStackGalleryCurrentImageStatus() {
      if (this.options['galleryDesign'] == 'stack_images') {
        let stackElement = this.element.querySelector(".ProductGallery--stack");

        if (stackElement) {
          let stackItems = stackElement.querySelectorAll('.Product__MediaWrapper');
          stackItems.forEach(function (item) {
            item.classList.remove("Product__MediaWrapper--currentVariantImage");
          });
          let stackItem = stackElement.querySelector('[data-media-id="' + this.options['initCurrentVariantImageId'] + '"]');

          if (stackItem) {
            stackItem.classList.add("Product__MediaWrapper--currentVariantImage"); // do not scroll when page loading
            // stackItem.scrollIntoView({ behavior: 'smooth', block:"start"});
          }
        }
      }
    }

  }

  class Currency {
    static formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }

      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
          formatString = format || '${{amount}}';

      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');

        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            centsAmount = parts[1] ? decimal + parts[1] : '';
        return dollarsAmount + centsAmount;
      }

      var value = '';

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;

        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;

        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;

        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, ',', '.');
          break;

        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;

        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
      }

      if (formatString.indexOf('with_comma_separator') !== -1) {
        return formatString.replace(placeholderRegex, value).replace(',00', '');
      } else {
        return formatString.replace(placeholderRegex, value).replace('.00', '');
      }
    }

  }

  class ShippingEstimator {
    constructor(element) {
      this.element = element;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.countrySelector = new CountrySelector(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]'));

      this._bindEventsListeners();
    }

    onUnload() {
      this.delegateElement.off('click');
      this.countrySelector.destroy();
    }

    _bindEventsListeners() {
      this.delegateElement.on('click', '.ShippingEstimator__Submit', this._fetchRates.bind(this));
    }

    _fetchRates() {
      var _this = this;

      var country = this.element.querySelector('[name="country"]').value,
          province = this.element.querySelector('[name="province"]').value,
          zip = this.element.querySelector('[name="zip"]').value;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      fetch(window.routes.cartUrl + '/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        response.json().then(function (result) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));

          var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
              errorContainer = _this.element.querySelector('.ShippingEstimator__Error');

          if (response.ok) {
            var shippingRates = result['shipping_rates'];

            if (shippingRates.length === 0) {
              resultsContainer.innerHTML = '<div class="Alert Alert--danger"><p class="Alert__Title">' + window.languages.shippingEstimatorNoResults + '</p></div>';
            } else {
              let html = '';

              if (shippingRates.length === 1) {
                html += '<div class="Alert Alert--success"><p class="Alert__Title">' + window.languages.shippingEstimatorOneResult + '</p><ul class="List List--unstyle">';
              } else {
                html += '<div class="Alert Alert--success"><p class="Alert__Title">' + window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length) + '</p><ul class="List List--unstyle">';
              }

              shippingRates.forEach(function (item) {
                html += '<li>' + item['name'] + ': ' + Currency.formatMoney(item['price'], window.theme.moneyFormat) + '</li>';
              });
              html += '</ul></div>';
              resultsContainer.innerHTML = html;
            }

            themegoal.libs.anime({
              targets: resultsContainer,
              opacity: [0, 1],
              translateY: [-15, 0],
              duration: 600,
              easing: 'cubicBezier(.5, .05, .1, .3)',
              delay: 350
            });
            errorContainer.style.display = 'none';
            resultsContainer.style.display = 'block';
          } else {
            var errorHtml = '';
            Object.keys(result).forEach(function (key) {
              // errorHtml += '<li>' + key + ' ' + result[key] + '</li>';
              errorHtml += '<li>' + result[key] + '</li>';
            });
            errorContainer.innerHTML = '<ul class="List List--unstyle">' + errorHtml + '</ul>';
            resultsContainer.style.display = 'none';
            errorContainer.style.display = 'block';
          }
        });
      });
    }

  }

  class CartSection {
    constructor(container) {
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];

      if (this.options['hasShippingEstimator']) {
        this.shippingEstimator = new ShippingEstimator(this.element.querySelector('.ShippingEstimator'));
      }

      this._bindEventsListeners();

      this._loadShippingAmountNotice();
    }

    onUnload() {
      if (this.options['hasShippingEstimator']) {
        this.shippingEstimator.countrySelector.destroy();
      }

      this.delegateElement.off();
    }

    _bindEventsListeners() {
      this.delegateElement.on('change', '#CartNote', this._updateCartNote.bind(this));
      this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
      this.delegateElement.on('change', '.CartItem__QuantityNum', this._updateItemQuantity.bind(this));
      this.delegateElement.on('main-cart:refresh', this._rerenderCart.bind(this, false));
    }

    _updateCartNote(event, target) {
      fetch(window.routes.cartUrl + '/update.js', {
        body: JSON.stringify({
          note: target.value
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      });
    }

    _updateItemQuantity(event, target) {
      var _this = this;

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      var quantity = null,
          elementToAnimate = null; //直接改或者使用+ - 按钮

      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        //+ - 按钮
        quantity = parseInt(target.getAttribute('data-quantity'));
      } // If the quantity is 0, then we will animate the product with a removal effect


      if (quantity === 0) {
        elementToAnimate = target.closest('.CartItem__Wrapper');
      }

      fetch(window.routes.cartChangeUrl + '.js', {
        body: JSON.stringify({
          id: target.getAttribute('data-line-id'),
          quantity: quantity
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      }).then(function (cart) {
        cart.json().then(function (content) {
          _this.itemCount = content['item_count'];

          _this._rerenderCart(elementToAnimate);

          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
      event.preventDefault();
    }

    _rerenderCart(elementToAnimate) {
      var _this = this;

      return fetch(window.routes.cartUrl + '?timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        // If there is an element to animate, we animate it using a transition
        if (elementToAnimate) {
          themegoal.libs.anime({
            targets: elementToAnimate,
            opacity: 0,
            height: 0,
            duration: 500,
            easing: 'easeOutCubic',
            complete: function (anim) {
              content.text().then(function (html) {
                _this._replaceContent(html);
              });
            }
          });
        } else {
          content.text().then(function (html) {
            _this._replaceContent(html);
          });
        }
      });
    }

    _replaceContent(html) {
      let _this = this;

      let tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      let cartNodeParent = this.element.querySelector('.Form--cart').parentNode; // For dedicated page we replace the whole section if there is no more product

      if (this.itemCount === 0) {
        this.element.innerHTML = tempElement.querySelector('.shopify-section .Cart').firstElementChild.innerHTML;
      } else {
        cartNodeParent.replaceChild(tempElement.querySelector('.Form--cart'), this.element.querySelector('.Form--cart'));
      } // We can also update the dot and the quantity of header icon


      let cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart"]').getAttribute('data-section-settings'));
      let cartCount = Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble')),
          cartText = Dom.nodeListToArray(document.querySelectorAll('.CartCountText')),
          cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble__Count'));
      this.itemCount = cartResult['itemCount'];
      cartCount.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.remove('Visible');
        } else {
          item.classList.add('Visible');
        }
      });
      cartText.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.add('Visible');
        } else {
          item.classList.remove('Visible');
        }
      });
      cartQuantity.forEach(function (item) {
        item.textContent = _this.itemCount;
      });

      this._loadShippingAmountNotice();
    }

    _loadShippingAmountNotice() {
      if (this.options["freeShippingThreshold"]) {
        let freeShippingElement = this.element.querySelector(".Cart__ShippingAmountNotice");
        let cartForm = this.element.querySelector(".Form--cart");

        if (freeShippingElement && cartForm) {
          let cartTotalPrice = cartForm.getAttribute("data-cart-total-price");
          let cartCurrencySymbol = cartForm.getAttribute("data-cart-currency-symbol");
          cartTotalPrice = parseInt(cartTotalPrice);
          let freeShippingAmount = Math.round(this.options["freeShippingAmount"] * (Shopify.currency.rate || 1));

          if (cartTotalPrice >= freeShippingAmount) {
            freeShippingElement.innerHTML = this.options["freeShippingString"];
          } else {
            let freeShippingAmountString = this.options["freeShippingAmountString"];
            freeShippingAmountString = freeShippingAmountString.replace("remaining__amount", "" + cartCurrencySymbol + (freeShippingAmount - cartTotalPrice) / 100);
            freeShippingElement.innerHTML = freeShippingAmountString;
          }
        }
      }
    }

  }

  class TestimonialsSection {
    constructor(container) {
      this.element = container;
      this.carousel = new Carousel(this.element.querySelector('.Testimonials__Body'));
    }

    onUnload() {
      this.carousel.destroy();
    }

    onBlockSelect(event) {
      this.carousel.selectCell(event.target.getAttribute('data-slide-index'), true);
    }

    onBlockDeselect() {
      this.carousel.unpausePlayer();
    }

  }

  class FeaturedCollectionSection {
    constructor(container) {
      var _this = this;

      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.carousels = [];
      Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      });
      this.allReveal = [];

      this._setupAnimation();
    }

    onUnload() {
      this.carousels.forEach(function (item) {
        return item.destroy();
      });
      this.delegateElement.off('click');

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    _setupAnimation() {
      var _this = this;

      this.allReveal = [];

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      if (this.options['layout'] === 'grid') {
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll('.ProductList--grid .ProductCard')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }

    _reveal(results) {
      var _this = this;

      var toReveal = [];
      results.forEach(function (result) {
        if (result.isIntersecting || result.intersectionRatio > 0) {
          // isIntersecting does not exist on Samsung Android browser
          toReveal.push(result.target);

          _this.allReveal.push(result.target);

          _this.intersectionObserver.unobserve(result.target);
        }
      });

      if (toReveal.length === 0) {
        return;
      }

      themegoal.libs.anime({
        targets: toReveal,
        opacity: [0, 1],
        translateY: [30, 0],
        delay: 500,
        duration: 500,
        easing: 'cubicBezier(.5, .05, .1, .3)',
        delay: themegoal.libs.anime.stagger(300)
      });
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME$2 = 'Collapse';
  const DATA_KEY$2 = 'tg.Collapse';
  const EVENT_KEY$2 = `.${DATA_KEY$2}`;
  const DATA_API_KEY$2 = '.data-api';
  const Default$1 = {
    toggle: true,
    parent: null
  };
  const DefaultType$1 = {
    toggle: 'boolean',
    parent: '(null|element)'
  };
  const EVENT_SHOW$2 = `show${EVENT_KEY$2}`;
  const EVENT_SHOWN$2 = `shown${EVENT_KEY$2}`;
  const EVENT_HIDE$2 = `hide${EVENT_KEY$2}`;
  const EVENT_HIDDEN$2 = `hidden${EVENT_KEY$2}`;
  const EVENT_CLICK_DATA_API$2 = `click${EVENT_KEY$2}${DATA_API_KEY$2}`;
  const CLASS_NAME_SHOW$2 = 'Show';
  const CLASS_NAME_COLLAPSE = 'Collapse';
  const CLASS_NAME_COLLAPSING = 'Collapsing';
  const CLASS_NAME_COLLAPSED = 'Collapsed';
  const CLASS_NAME_HORIZONTAL = 'Collapse--horizontal';
  const WIDTH = 'width';
  const HEIGHT = 'height';
  const SELECTOR_ACTIVES = '.Collapse.Show, .Collapse.Collapsing';
  const SELECTOR_DATA_TOGGLE$2 = '[data-tg-toggle="Collapse"]';
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class Collapse extends BaseComponent {
    constructor(element, config) {
      super(element);
      this._isTransitioning = false;
      this._config = this._getConfig(config);
      this._triggerArray = [];
      const toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$2);

      for (let i = 0, len = toggleList.length; i < len; i++) {
        const elem = toggleList[i];
        const selector = getSelectorFromElement(elem);
        const filterElement = SelectorEngine.find(selector).filter(foundElem => foundElem === this._element);

        if (selector !== null && filterElement.length) {
          this._selector = selector;

          this._triggerArray.push(elem);
        }
      }

      this._initializeChildren();

      if (!this._config.parent) {
        this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
      }

      if (this._config.toggle) {
        this.toggle();
      }
    } // Getters


    static get Default() {
      return Default$1;
    }

    static get NAME() {
      return NAME$2;
    } // Public


    toggle() {
      if (this._isShown()) {
        this.hide();
      } else {
        this.show();
      }
    }

    show() {
      if (this._isTransitioning || this._isShown()) {
        return;
      }

      let actives = [];
      let activesData;

      if (this._config.parent) {
        const children = SelectorEngine.find(`.${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`, this._config.parent);
        actives = SelectorEngine.find(SELECTOR_ACTIVES, this._config.parent).filter(elem => !children.includes(elem)); // remove children if greater depth
      }

      const container = SelectorEngine.findOne(this._selector);

      if (actives.length) {
        const tempActiveData = actives.find(elem => container !== elem);
        activesData = tempActiveData ? Collapse.getInstance(tempActiveData) : null;

        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      const startEvent = EventHandler.trigger(this._element, EVENT_SHOW$2);

      if (startEvent.defaultPrevented) {
        return;
      }

      actives.forEach(elemActive => {
        if (container !== elemActive) {
          Collapse.getOrCreateInstance(elemActive, {
            toggle: false
          }).hide();
        }

        if (!activesData) {
          Data.set(elemActive, DATA_KEY$2, null);
        }
      });

      const dimension = this._getDimension();

      this._element.classList.remove(CLASS_NAME_COLLAPSE);

      this._element.classList.add(CLASS_NAME_COLLAPSING);

      this._element.style[dimension] = 0;

      this._addAriaAndCollapsedClass(this._triggerArray, true);

      this._isTransitioning = true;

      const complete = () => {
        this._isTransitioning = false;

        this._element.classList.remove(CLASS_NAME_COLLAPSING);

        this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$2);

        this._element.style[dimension] = '';
        EventHandler.trigger(this._element, EVENT_SHOWN$2);
      };

      const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      const scrollSize = `scroll${capitalizedDimension}`;

      this._queueCallback(complete, this._element, true);

      this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }

    hide() {
      if (this._isTransitioning || !this._isShown()) {
        return;
      }

      const startEvent = EventHandler.trigger(this._element, EVENT_HIDE$2);

      if (startEvent.defaultPrevented) {
        return;
      }

      const dimension = this._getDimension();

      this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
      reflow(this._element);

      this._element.classList.add(CLASS_NAME_COLLAPSING);

      this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$2);

      const triggerArrayLength = this._triggerArray.length;

      for (let i = 0; i < triggerArrayLength; i++) {
        const trigger = this._triggerArray[i];
        const elem = getElementFromSelector(trigger);

        if (elem && !this._isShown(elem)) {
          this._addAriaAndCollapsedClass([trigger], false);
        }
      }

      this._isTransitioning = true;

      const complete = () => {
        this._isTransitioning = false;

        this._element.classList.remove(CLASS_NAME_COLLAPSING);

        this._element.classList.add(CLASS_NAME_COLLAPSE);

        EventHandler.trigger(this._element, EVENT_HIDDEN$2);
      };

      this._element.style[dimension] = '';

      this._queueCallback(complete, this._element, true);
    }

    _isShown(element = this._element) {
      return element.classList.contains(CLASS_NAME_SHOW$2);
    } // Private


    _getConfig(config) {
      config = { ...Default$1,
        ...Manipulator.getDataAttributes(this._element),
        ...config
      };
      config.toggle = Boolean(config.toggle); // Coerce string values

      config.parent = getElement(config.parent);
      typeCheckConfig(NAME$2, config, DefaultType$1);
      return config;
    }

    _getDimension() {
      return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
    }

    _initializeChildren() {
      if (!this._config.parent) {
        return;
      }

      const children = SelectorEngine.find(`.${CLASS_NAME_COLLAPSE} .${CLASS_NAME_COLLAPSE}`, this._config.parent);
      SelectorEngine.find(SELECTOR_DATA_TOGGLE$2, this._config.parent).filter(elem => !children.includes(elem)).forEach(element => {
        const selected = getElementFromSelector(element);

        if (selected) {
          this._addAriaAndCollapsedClass([element], this._isShown(selected));
        }
      });
    }

    _addAriaAndCollapsedClass(triggerArray, isOpen) {
      if (!triggerArray.length) {
        return;
      }

      triggerArray.forEach(elem => {
        if (isOpen) {
          elem.classList.remove(CLASS_NAME_COLLAPSED);
        } else {
          elem.classList.add(CLASS_NAME_COLLAPSED);
        }

        elem.setAttribute('aria-expanded', isOpen);
      });
    }

  }
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') {
      event.preventDefault();
    }

    const selector = getSelectorFromElement(this);
    const selectorElements = SelectorEngine.find(selector);
    selectorElements.forEach(element => {
      Collapse.getOrCreateInstance(element, {
        toggle: false
      }).toggle();
    });
  });

  class CartDrawerSection {
    constructor(container) {
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.documentDelegate = new themegoal.libs.Delegate(document.documentElement);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.itemCount = this.options['itemCount'];
      this.sidebarDrawer = new Drawer(container);
      this.element.addEventListener('hidden.tg.Drawer', this._onDrawerClosed.bind(this));

      this._bindEventsListeners();
    }

    onUnload() {
      this.delegateElement.off();
      document.removeEventListener('product:added', this._onProductAdded.bind(this));
    } // onSelect(event) {
    //   this.sidebarDrawer.show();
    // }
    // onDeselect(event) {
    //   this.sidebarDrawer.hide();
    // }


    _bindEventsListeners() {
      this.delegateElement.on('change', '#CartNote', this._updateCartNote.bind(this));
      this.delegateElement.on('click', '[data-action="update-item-quantity"], [data-action="remove-item"]', this._updateItemQuantity.bind(this));
      this.delegateElement.on('change', '.CartItem__QuantityNum', this._updateItemQuantity.bind(this));
      document.addEventListener('product:added', this._onProductAdded.bind(this)); // re-render the drawer cart with event cart:refresh

      this.documentDelegate.on('cart:refresh', this._rerenderCart.bind(this, false));
    }

    _updateCartNote(event, target) {
      fetch(window.routes.cartUrl + '/update.js', {
        body: JSON.stringify({
          note: target.value
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      });
    }

    _updateItemQuantity(event, target) {
      var _this = this;

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      var quantity = null,
          elementToAnimate = null;

      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        //+ - 按钮
        quantity = parseInt(target.getAttribute('data-quantity'));
      } // If the quantity is 0, then we will animate the product with a removal effect


      if (quantity === 0) {
        elementToAnimate = target.closest('.CartItem__Wrapper');
      }

      fetch(window.routes.cartChangeUrl + '.js', {
        body: JSON.stringify({
          id: target.getAttribute('data-line-id'),
          quantity: quantity
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

        }
      }).then(function (cart) {
        cart.json().then(function (content) {
          _this.itemCount = content['item_count'];

          _this._rerenderCart(elementToAnimate);

          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
      event.preventDefault();
    }

    _onProductAdded(event) {
      var _this = this;

      this.itemCount += event.detail.quantity;

      this._rerenderCart().then(function () {
        _this.sidebarDrawer.show();
      });
    }

    _onDrawerClosed() {
      let cartDrawerNoteElement = document.getElementById('CartDrawerNoteCollapse');

      if (cartDrawerNoteElement) {
        let cartDrawerNoteCollapse = new Collapse(cartDrawerNoteElement, {
          toggle: false
        });
        cartDrawerNoteCollapse.hide();
      }
    }

    _rerenderCart(elementToAnimate) {
      var _this = this; // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property


      return fetch(window.routes.cartUrl + '?section_id=cart-drawer&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (content) {
        // If there is an element to animate, we animate it using a transition
        if (elementToAnimate) {
          themegoal.libs.anime({
            targets: elementToAnimate,
            opacity: 0,
            height: 0,
            duration: 500,
            easing: 'easeOutCubic',
            complete: function (anim) {
              content.text().then(function (html) {
                _this._replaceContent(html);
              });
            }
          });
        } else {
          content.text().then(function (html) {
            _this._replaceContent(html);
          });
        }
      });
    }

    _replaceContent(html) {
      let _this = this;

      let tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      let cartNodeParent = this.element.querySelector('.Form--cart').parentNode;
      let currentScrollPosition = this.element.querySelector('.Drawer__Body').scrollTop;
      cartNodeParent.replaceChild(tempElement.querySelector('.Form--cart'), this.element.querySelector('.Form--cart'));
      this.element.querySelector('.Drawer__Body').scrollTop = currentScrollPosition; // We can also update the dot and the quantity of header icon

      let cartResult = JSON.parse(tempElement.querySelector('[data-section-type="cart-drawer"]').getAttribute('data-section-settings'));
      let cartCount = Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble')),
          cartText = Dom.nodeListToArray(document.querySelectorAll('.CartCountText')),
          cartQuantity = Dom.nodeListToArray(document.querySelectorAll('.CartCountBubble__Count'));
      this.itemCount = cartResult['itemCount'];
      cartCount.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.remove('Visible');
        } else {
          item.classList.add('Visible');
        }
      });
      cartText.forEach(function (item) {
        if (_this.itemCount === 0) {
          item.classList.add('Visible');
        } else {
          item.classList.remove('Visible');
        }
      });
      cartQuantity.forEach(function (item) {
        item.textContent = _this.itemCount;
      });

      if (this.options["freeShippingThreshold"]) {
        let freeShippingElement = cartNodeParent.querySelector(".CartDrawer__ShippingAmountNotice");

        if (freeShippingElement) {
          let cartTotalPrice = freeShippingElement.getAttribute("data-cart-total-price");
          let cartCurrencySymbol = freeShippingElement.getAttribute("data-cart-currency-symbol");
          cartTotalPrice = parseInt(cartTotalPrice);
          let freeShippingAmount = Math.round(this.options["freeShippingAmount"] * (Shopify.currency.rate || 1));

          if (cartTotalPrice >= freeShippingAmount) {
            freeShippingElement.innerHTML = this.options["freeShippingString"];
          } else {
            let freeShippingAmountString = this.options["freeShippingAmountString"];
            freeShippingAmountString = freeShippingAmountString.replace("remaining__amount", "" + cartCurrencySymbol + (freeShippingAmount - cartTotalPrice) / 100);
            freeShippingElement.innerHTML = freeShippingAmountString;
          }
        }
      }
    }

  }

  class GiftCardSection {
    constructor(container) {
      this.element = container;

      this._createQrCode();

      this._setupPrint();
    }

    _createQrCode() {
      var qrCodeElement = document.getElementById('QRCode');
      new QRCode(qrCodeElement, {
        text: qrCodeElement.getAttribute('data-identifier'),
        width: 120,
        height: 120
      });
    }

    _setupPrint() {
      var printElement = document.getElementById('PrintGiftCard');

      if (printElement) {
        printElement.addEventListener('click', function () {
          window.print();
        });
      }
    }

  }

  class FeaturedProductSection {
    constructor(container) {
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));

      if (this.element.querySelector('[data-product-json]')) {
        this.productVariants = new ProductVariants(container, this.options);
      }

      this._bindEventsListeners();
    }

    onUnload() {
      this.delegateElement.off('click');

      if (this.productVariants) {
        this.productVariants.destroy();
      }
    }

    _bindEventsListeners() {
      this.delegateElement.on('variant:changed', this._updateMainImage.bind(this));
    }

    _updateMainImage(event) {
      var variant = event.detail.variant,
          previousVariant = event.detail.previousVariant;

      if (!variant || !variant['featured_image'] || previousVariant['featured_image'] && previousVariant['featured_image']['id'] === variant['featured_image']['id']) {
        return;
      }

      var newImage = variant['featured_image'];
      var mainImageContainer = this.element.querySelector('.FeaturedProduct__Gallery .Ratio');
      mainImageContainer.style.cssText = 'max-width: ' + newImage['width'] + 'px; --tg-aspect-ratio: ' + newImage['width'] / newImage['height'];
      var newImageElement = document.createElement('img');
      newImageElement.setAttribute('src', newImage['src']);
      mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));
    }

  }

  class ProductQuickviewSection {
    constructor(container) {
      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.quiviewModal = null;

      if (this.element.querySelector('[data-product-json]')) {
        this.productVariants = new ProductVariants(container, this.options);
      }

      this._bindEventsListeners();
    }

    onUnload() {
      this.delegateElement.off('click');

      if (this.productVariants) {
        this.productVariants.destroy();
      }

      if (this.quiviewModal) this.quiviewModal.hide();
    }

    onSelect(event) {
      document.querySelector("body").style.removeProperty('overflow');
      let ele = document.getElementById('ProductQuickviewModal');
      this.quiviewModal = Modal.getOrCreateInstance(ele);
      this.quiviewModal.show();
    }

    onDeselect(event) {
      if (this.quiviewModal) this.quiviewModal.hide();
    }

    _bindEventsListeners() {
      this.delegateElement.on('variant:changed', this._updateMainImage.bind(this));
    }

    _updateMainImage(event) {
      var variant = event.detail.variant;

      if (!variant || !variant['featured_image']) {
        return;
      }

      var newImage = variant['featured_image'];
      var mainImageContainer = this.element.querySelector('.ProductQuickview__Gallery .Ratio');
      mainImageContainer.style.cssText = 'max-width: ' + newImage['width'] + 'px; --tg-aspect-ratio: ' + newImage['width'] / newImage['height'];
      var newImageElement = document.createElement('img');
      newImageElement.setAttribute('src', newImage['src']);
      mainImageContainer.replaceChild(newImageElement, mainImageContainer.querySelector('img'));
    }

  }

  class FeaturedNavSection {
    constructor(container) {
      var _this = this;

      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.carousels = [];
      Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
        _this.carousels.push(new Carousel(item));
      });
      this.allReveal = [];

      this._setupAnimation();
    }

    onUnload() {
      this.carousels.forEach(function (item) {
        return item.destroy();
      });
      this.delegateElement.off('click');

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    _setupAnimation() {
      var _this = this;

      this.allReveal = [];

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      if (this.options['layout'] === 'grid') {
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll('.NavCardList--grid .NavCard')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }

    _reveal(results) {
      var _this = this;

      var toReveal = [];
      results.forEach(function (result) {
        if (result.isIntersecting || result.intersectionRatio > 0) {
          // isIntersecting does not exist on Samsung Android browser
          toReveal.push(result.target);

          _this.allReveal.push(result.target);

          _this.intersectionObserver.unobserve(result.target);
        }
      });

      if (toReveal.length === 0) {
        return;
      }

      themegoal.libs.anime({
        targets: toReveal,
        opacity: [0, 1],
        translateY: [30, 0],
        delay: 500,
        duration: 500,
        easing: 'cubicBezier(.5, .05, .1, .3)',
        delay: themegoal.libs.anime.stagger(300)
      });
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME$1 = 'Tab';
  const DATA_KEY$1 = 'tg.Tab';
  const EVENT_KEY$1 = `.${DATA_KEY$1}`;
  const DATA_API_KEY$1 = '.data-api';
  const EVENT_HIDE$1 = `hide${EVENT_KEY$1}`;
  const EVENT_HIDDEN$1 = `hidden${EVENT_KEY$1}`;
  const EVENT_SHOW$1 = `show${EVENT_KEY$1}`;
  const EVENT_SHOWN$1 = `shown${EVENT_KEY$1}`;
  const EVENT_CLICK_DATA_API$1 = `click${EVENT_KEY$1}${DATA_API_KEY$1}`;
  const CLASS_NAME_ACTIVE = 'Active';
  const CLASS_NAME_FADE = 'Fade';
  const CLASS_NAME_SHOW$1 = 'Show';
  const SELECTOR_NAV_LIST_GROUP = '.Nav, .List--tabs';
  const SELECTOR_ACTIVE = '.Active';
  const SELECTOR_ACTIVE_UL = ':scope > li > .Active';
  const SELECTOR_DATA_TOGGLE$1 = '[data-tg-toggle="Tab"]';
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class Tab extends BaseComponent {
    // Getters
    static get NAME() {
      return NAME$1;
    } // Public


    show() {
      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(CLASS_NAME_ACTIVE)) {
        return;
      }

      let previous;
      const target = getElementFromSelector(this._element);

      const listElement = this._element.closest(SELECTOR_NAV_LIST_GROUP);

      if (listElement) {
        const itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
        previous = SelectorEngine.find(itemSelector, listElement);
        previous = previous[previous.length - 1];
      }

      const hideEvent = previous ? EventHandler.trigger(previous, EVENT_HIDE$1, {
        relatedTarget: this._element
      }) : null;
      const showEvent = EventHandler.trigger(this._element, EVENT_SHOW$1, {
        relatedTarget: previous
      });

      if (showEvent.defaultPrevented || hideEvent !== null && hideEvent.defaultPrevented) {
        return;
      }

      this._activate(this._element, listElement);

      const complete = () => {
        EventHandler.trigger(previous, EVENT_HIDDEN$1, {
          relatedTarget: this._element
        });
        EventHandler.trigger(this._element, EVENT_SHOWN$1, {
          relatedTarget: previous
        });
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    } // Private


    _activate(element, container, callback) {
      const activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? SelectorEngine.find(SELECTOR_ACTIVE_UL, container) : SelectorEngine.children(container, SELECTOR_ACTIVE);
      const active = activeElements[0];
      const isTransitioning = callback && active && active.classList.contains(CLASS_NAME_FADE);

      const complete = () => this._transitionComplete(element, active, callback);

      if (active && isTransitioning) {
        active.classList.remove(CLASS_NAME_SHOW$1);

        this._queueCallback(complete, element, true);
      } else {
        complete();
      }
    }

    _transitionComplete(element, active, callback) {
      if (active) {
        active.classList.remove(CLASS_NAME_ACTIVE);

        if (active.getAttribute('role') === 'tab') {
          active.setAttribute('aria-selected', false);
        }
      }

      element.classList.add(CLASS_NAME_ACTIVE);

      if (element.getAttribute('role') === 'tab') {
        element.setAttribute('aria-selected', true);
      }

      reflow(element);

      if (element.classList.contains(CLASS_NAME_FADE)) {
        element.classList.add(CLASS_NAME_SHOW$1);
      }

      let parent = element.parentNode;

      if (parent && parent.nodeName === 'LI') {
        parent = parent.parentNode;
      }

      if (callback) {
        callback();
      }
    }

  }
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
    if (['A', 'AREA'].includes(this.tagName)) {
      event.preventDefault();
    }

    if (isDisabled(this)) {
      return;
    }

    const data = Tab.getOrCreateInstance(this);
    data.show();
  });

  class TabCollectionsSection {
    constructor(container) {
      var _this = this;

      this.element = container;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
      this.carousels = [];
      this.tabs = [];

      if (this.options['layout'] === 'carousel') {
        Dom.nodeListToArray(this.element.querySelectorAll('[data-flickity-config]')).forEach(function (item) {
          _this.carousels.push(new Carousel(item));
        });
      }

      Dom.nodeListToArray(this.element.querySelectorAll('.Nav--tabs .Button')).forEach(function (item) {
        let tab = new Tab(item);

        _this.tabs.push(tab);

        if (_this.options['layout'] === 'carousel') {
          item.addEventListener('shown.tg.Tab', event => {
            // console.log(event.target); // newly activated tab
            // console.log(event.relatedTarget) // previous active tab
            let contentId = event.target.getAttribute("data-tg-target");

            if (contentId) {
              let contentElement = _this.element.querySelector(contentId);

              if (contentElement) {
                let tagetCarousel = contentElement.querySelector('[data-flickity-config]');

                if (tagetCarousel) {
                  let flkty = Flickity.data(tagetCarousel);
                  flkty.resize();
                }
              }
            }
          });
        }
      });
      this.allReveal = [];

      this._setupAnimation();
    }

    onUnload() {
      if (this.options['layout'] === 'carousel') {
        this.carousels.forEach(function (item) {
          return item.destroy();
        });
      }

      this.delegateElement.off('click');

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
    }

    _setupAnimation() {
      var _this = this;

      this.allReveal = [];

      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }

      if (this.options['layout'] === 'grid') {
        this.intersectionObserver = new IntersectionObserver(this._reveal.bind(this));
        Dom.nodeListToArray(this.element.querySelectorAll('.ProductList--grid .ProductCard')).forEach(function (item) {
          _this.intersectionObserver.observe(item);
        });
      }
    }

    _reveal(results) {
      var _this = this;

      var toReveal = [];
      results.forEach(function (result) {
        if (result.isIntersecting || result.intersectionRatio > 0) {
          // isIntersecting does not exist on Samsung Android browser
          toReveal.push(result.target);

          _this.allReveal.push(result.target);

          _this.intersectionObserver.unobserve(result.target);
        }
      });

      if (toReveal.length === 0) {
        return;
      }

      themegoal.libs.anime({
        targets: toReveal,
        opacity: [0, 1],
        translateY: [30, 0],
        delay: 500,
        duration: 500,
        easing: 'cubicBezier(.5, .05, .1, .3)',
        delay: themegoal.libs.anime.stagger(300)
      });
    }

  }

  class SectionContainer {
    constructor() {
      this.constructors = [];
      this.instances = [];

      this._bindEventsListeners();
    }

    _bindEventsListeners() {
      document.addEventListener('shopify:section:load', this._onSectionLoad.bind(this));
      document.addEventListener('shopify:section:unload', this._onSectionUnload.bind(this));
      document.addEventListener('shopify:section:select', this._onSelect.bind(this));
      document.addEventListener('shopify:section:deselect', this._onDeselect.bind(this));
      document.addEventListener('shopify:section:reorder', this._onReorder.bind(this));
      document.addEventListener('shopify:block:select', this._onBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this._onBlockDeselect.bind(this));
    }

    register(type, constructor) {
      var _this = this;

      this.constructors[type] = constructor;
      Dom.nodeListToArray(document.querySelectorAll('[data-section-type=' + type + ']')).forEach(function (container) {
        _this._createInstance(container, constructor);
      });
    }
    /**
     * Return an object from an array of objects that matches the provided key and value
     */


    _findInstance(array, key, value) {
      for (var i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
    }
    /**
     * Remove an object from an array of objects by matching the provided key and value
     */


    _removeInstance(array, key, value) {
      var i = array.length;

      while (i--) {
        if (array[i][key] === value) {
          array.splice(i, 1);
          break;
        }
      }

      return array;
    }

    _onSectionLoad(event) {
      var container = event.target.querySelector('[data-section-id]');

      if (container) {
        this._createInstance(container);
      }
    }

    _onSectionUnload(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

      if (!instance) {
        return;
      }

      if (typeof instance.onUnload === 'function') {
        instance.onUnload(event);
      }

      this.instances = this._removeInstance(this.instances, 'id', event.detail.sectionId);
    }

    _onSelect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

      if (instance && typeof instance.onSelect === 'function') {
        instance.onSelect(event);
      }
    }

    _onDeselect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

      if (instance && typeof instance.onDeselect === 'function') {
        instance.onDeselect(event);
      }
    }

    _onReorder(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

      if (instance && typeof instance.onReorder === 'function') {
        instance.onReorder(event);
      }
    }

    _onBlockSelect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

      if (instance && typeof instance.onBlockSelect === 'function') {
        instance.onBlockSelect(event);
      }
    }

    _onBlockDeselect(event) {
      var instance = this._findInstance(this.instances, 'id', event.detail.sectionId);

      if (instance && typeof instance.onBlockDeselect === 'function') {
        instance.onBlockDeselect(event);
      }
    }

    _createInstance(container, constructor) {
      var id = container.getAttribute('data-section-id'),
          type = container.getAttribute('data-section-type');
      constructor = constructor || this.constructors[type];

      if (typeof constructor === 'undefined') {
        return;
      }

      var instance = Object.assign(new constructor(container), {
        id: id,
        type: type,
        container: container
      });
      this.instances.push(instance);
    }

  }

  class ProductQuickvew {
    constructor() {
      this.element = document.body;
      this.delegateElement = new themegoal.libs.Delegate(this.element);
      this.quiviewModal = null;

      this._attachListeners();
    }

    _attachListeners() {
      this.delegateElement.on('click', '[data-tg-action="product-quickview-modal"]', this._debounce(this._openModal.bind(this), 1000));
    }

    _openModal(event, target) {
      let _this = this;

      let productURL = target.getAttribute('data-product-handle');

      if (productURL) {
        document.dispatchEvent(new CustomEvent('theme:loading:start'));
        target.classList.add("Loading");
        fetch(window.routes.rootUrlWithoutSlash + '/products/' + productURL + '?section_id=product-quickview', {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            document.dispatchEvent(new CustomEvent('theme:loading:end'));
            target.classList.remove("Loading"); //   document.getElementById("modal-product-quickview").classList.remove("modal--lazy-loadding");

            var tempElement = document.createElement('div');
            tempElement.innerHTML = content;
            _this.element.querySelector("#shopify-section-product-quickview").innerHTML = tempElement.querySelector("#shopify-section-product-quickview").innerHTML;
            var sectionContainer = new SectionContainer();
            sectionContainer.register('product-quickview', ProductQuickviewSection);
            let ele = document.getElementById('ProductQuickviewModal'); //fixed 

            document.querySelector("body").style.removeProperty('overflow');
            _this.quiviewModal = new Modal(ele);

            _this.quiviewModal.show();
          });
        });
      }
    }

    _debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

  }

  class LoadingBar {
    constructor() {
      this.element = document.querySelector('.LoadingBar');
      document.addEventListener('theme:loading:start', this._onLoadingStart.bind(this));
      document.addEventListener('theme:loading:end', this._onLoadingEnd.bind(this));
      this.element.addEventListener('transitionend', this._onTransitionEnd.bind(this));
    }

    _onLoadingStart() {
      this.element.classList.add('Visible');
      this.element.style.width = '40%';
    }

    _onLoadingEnd() {
      this.element.style.width = '100%';
      this.element.classList.add('Finished');
    }

    _onTransitionEnd(event) {
      if (event.propertyName === 'width' && this.element.classList.contains('Finished')) {
        this.element.classList.remove('Visible');
        this.element.classList.remove('Finished');
        this.element.style.width = '0';
      }
    }

  }

  class SearchDrawer {
    constructor() {
      this.documentDelegate = new themegoal.libs.Delegate(document.body);
      this.searchElement = document.getElementById('SearchDrawer');

      if (this.searchElement) {
        this.searchInputElement = this.searchElement.querySelector('[name="q"]');
        this.searchResultsElement = this.searchElement.querySelector('.SearchDrawer__Results');
        this.queryMap = {};

        this._bindEventsListeners();
      }
    }

    destroy() {
      this.searchInputElement.removeEventListener('input', this._onInputListener);
      this.documentDelegate.off();
    }

    _bindEventsListeners() {
      let _this = this;

      this.searchElement.addEventListener('shown.tg.Drawer', event => {
        _this.searchInputElement.focus();
      });
      this._onInputListener = this._debounce(this._onInput.bind(this), 250);
      this.searchInputElement.addEventListener('input', this._onInputListener);
      this.documentDelegate.on('search:close', this._closeSearch.bind(this)); // Allow for third-party elements to close the bar
    }

    _closeSearch() {
      let searchDrawerElement = document.getElementById('SearchDrawer');
      let searchDrawer = new Drawer(searchDrawerElement);
      searchDrawer.hide();
    }

    _onInput(event) {
      let _this = this;

      if (event.keyCode === 13) {
        return;
      } // Unfortunately, fetch does not support as of today cancelling a request. As a consequence what we do is that we manually
      // keep track of sent requests, and only use the results of the last one


      this.lastInputValue = event.target.value;

      if (this.lastInputValue === '') {
        this._resetSearch();

        return;
      }

      var queryOptions = {
        method: 'GET',
        credentials: 'same-origin'
      };
      var queries = [fetch(window.routes.searchUrl + '?q=' + encodeURIComponent(this.lastInputValue) + '&type=' + window.theme.searchMode + '&options[prefix]=last', queryOptions)];
      this.queryMap[this.lastInputValue] = true;
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      Promise.all(queries).then(function (responses) {
        // If we receive the result for a query that is not the last one, we simply do not process the result
        if (_this.lastInputValue !== event.target.value) {
          return;
        }

        delete _this.queryMap[event.target.value];
        Promise.all(responses.map(function (response) {
          return response.text();
        })).then(function (contents) {
          var tempElement = document.createElement('div');
          tempElement.innerHTML = contents[0]; // If we have only one content then we only have product, otherwise we have products and articles

          _this.searchResultsElement.querySelector('.SearchDrawer__ResultsContent').innerHTML = tempElement.querySelector('.FilterProducts__Content').innerHTML;

          if (tempElement.querySelector('.Results__SummaryForSearchDrawer')) {
            _this.searchResultsElement.querySelector('.SearchDrawer__ResultsSummary').innerHTML = tempElement.querySelector('.Results__SummaryForSearchDrawer').innerHTML;
          }

          _this.searchResultsElement.setAttribute('aria-hidden', 'false');
        });
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      });
    }

    _resetSearch() {
      this.searchResultsElement.querySelector('.SearchDrawer__ResultsContent').innerHTML = '';
      this.searchResultsElement.querySelector('.SearchDrawer__ResultsSummary').innerHTML = '';
      this.searchResultsElement.setAttribute('aria-hidden', 'true');
      document.dispatchEvent(new CustomEvent('theme:loading:end')); // Just in case
    }

    _debounce(fn, delay) {
      var _this = this;

      var timer = null;
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(_this, args);
        }, delay);
      };
    }

  }

  /**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.1): dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */
  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  const NAME = 'Dropdown';
  const DATA_KEY = 'tg.Dropdown';
  const EVENT_KEY = `.${DATA_KEY}`;
  const DATA_API_KEY = '.data-api';
  const ESCAPE_KEY = 'Escape';
  const SPACE_KEY = 'Space';
  const TAB_KEY = 'Tab';
  const ARROW_UP_KEY = 'ArrowUp';
  const ARROW_DOWN_KEY = 'ArrowDown';
  const RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button

  const REGEXP_KEYDOWN = new RegExp(`${ARROW_UP_KEY}|${ARROW_DOWN_KEY}|${ESCAPE_KEY}`);
  const EVENT_HIDE = `hide${EVENT_KEY}`;
  const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
  const EVENT_SHOW = `show${EVENT_KEY}`;
  const EVENT_SHOWN = `shown${EVENT_KEY}`;
  const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;
  const EVENT_KEYDOWN_DATA_API = `keydown${EVENT_KEY}${DATA_API_KEY}`;
  const EVENT_KEYUP_DATA_API = `keyup${EVENT_KEY}${DATA_API_KEY}`;
  const CLASS_NAME_SHOW = 'Show';
  const CLASS_NAME_DROPUP = 'Dropup';
  const CLASS_NAME_DROPEND = 'Dropend';
  const CLASS_NAME_DROPSTART = 'Dropstart';
  const CLASS_NAME_NAVBAR = 'navbar';
  const SELECTOR_DATA_TOGGLE = '[data-tg-toggle="Dropdown"]';
  const SELECTOR_MENU = '.Dropdown__Body';
  const SELECTOR_NAVBAR_NAV = '.Navbar-nav';
  const SELECTOR_VISIBLE_ITEMS = '.Dropdown__Body .Dropdown__Item:not(.Disabled):not(:disabled)';
  const PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
  const PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
  const PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
  const PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
  const PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
  const PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
  const Default = {
    offset: [0, 2],
    boundary: 'clippingParents',
    reference: 'toggle',
    display: 'dynamic',
    popperConfig: null,
    autoClose: true
  };
  const DefaultType = {
    offset: '(array|string|function)',
    boundary: '(string|element)',
    reference: '(string|element|object)',
    display: 'string',
    popperConfig: '(null|object|function)',
    autoClose: '(boolean|string)'
  };
  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */

  class Dropdown extends BaseComponent {
    constructor(element, config) {
      super(element);
      this._popper = null;
      this._config = this._getConfig(config);
      this._menu = this._getMenuElement();
      this._inNavbar = this._detectNavbar();
    } // Getters


    static get Default() {
      return Default;
    }

    static get DefaultType() {
      return DefaultType;
    }

    static get NAME() {
      return NAME;
    } // Public


    toggle() {
      return this._isShown() ? this.hide() : this.show();
    }

    show() {
      if (isDisabled(this._element) || this._isShown(this._menu)) {
        return;
      }

      const relatedTarget = {
        relatedTarget: this._element
      };
      const showEvent = EventHandler.trigger(this._element, EVENT_SHOW, relatedTarget);

      if (showEvent.defaultPrevented) {
        return;
      }

      const parent = Dropdown.getParentFromElement(this._element); // Totally disable Popper for Dropdowns in Navbar

      if (this._inNavbar) {
        Manipulator.setDataAttribute(this._menu, 'popper', 'none');
      } else {
        this._createPopper(parent);
      } // If this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement && !parent.closest(SELECTOR_NAVBAR_NAV)) {
        [].concat(...document.body.children).forEach(elem => EventHandler.on(elem, 'mouseover', noop));
      }

      this._element.focus();

      this._element.setAttribute('aria-expanded', true);

      this._menu.classList.add(CLASS_NAME_SHOW);

      this._element.classList.add(CLASS_NAME_SHOW);

      EventHandler.trigger(this._element, EVENT_SHOWN, relatedTarget);
    }

    hide() {
      if (isDisabled(this._element) || !this._isShown(this._menu)) {
        return;
      }

      const relatedTarget = {
        relatedTarget: this._element
      };

      this._completeHide(relatedTarget);
    }

    dispose() {
      if (this._popper) {
        this._popper.destroy();
      }

      super.dispose();
    }

    update() {
      this._inNavbar = this._detectNavbar();

      if (this._popper) {
        this._popper.update();
      }
    } // Private


    _completeHide(relatedTarget) {
      const hideEvent = EventHandler.trigger(this._element, EVENT_HIDE, relatedTarget);

      if (hideEvent.defaultPrevented) {
        return;
      } // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support


      if ('ontouchstart' in document.documentElement) {
        [].concat(...document.body.children).forEach(elem => EventHandler.off(elem, 'mouseover', noop));
      }

      if (this._popper) {
        this._popper.destroy();
      }

      this._menu.classList.remove(CLASS_NAME_SHOW);

      this._element.classList.remove(CLASS_NAME_SHOW);

      this._element.setAttribute('aria-expanded', 'false');

      Manipulator.removeDataAttribute(this._menu, 'popper');
      EventHandler.trigger(this._element, EVENT_HIDDEN, relatedTarget);
    }

    _getConfig(config) {
      config = { ...this.constructor.Default,
        ...Manipulator.getDataAttributes(this._element),
        ...config
      };
      typeCheckConfig(NAME, config, this.constructor.DefaultType);

      if (typeof config.reference === 'object' && !isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') {
        // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${NAME.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
      }

      return config;
    }

    _createPopper(parent) {
      if (typeof TGPopper === 'undefined') {
        throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
      }

      let referenceElement = this._element;

      if (this._config.reference === 'parent') {
        referenceElement = parent;
      } else if (isElement(this._config.reference)) {
        referenceElement = getElement(this._config.reference);
      } else if (typeof this._config.reference === 'object') {
        referenceElement = this._config.reference;
      }

      const popperConfig = this._getPopperConfig();

      const isDisplayStatic = popperConfig.modifiers.find(modifier => modifier.name === 'applyStyles' && modifier.enabled === false);
      this._popper = TGPopper.createPopper(referenceElement, this._menu, popperConfig);

      if (isDisplayStatic) {
        Manipulator.setDataAttribute(this._menu, 'popper', 'static');
      }
    }

    _isShown(element = this._element) {
      return element.classList.contains(CLASS_NAME_SHOW);
    }

    _getMenuElement() {
      return SelectorEngine.next(this._element, SELECTOR_MENU)[0];
    }

    _getPlacement() {
      const parentDropdown = this._element.parentNode;

      if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) {
        return PLACEMENT_RIGHT;
      }

      if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) {
        return PLACEMENT_LEFT;
      } // We need to trim the value because custom properties can also include spaces


      const isEnd = getComputedStyle(this._menu).getPropertyValue('--tg-position').trim() === 'end';

      if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) {
        return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
      }

      return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
    }

    _detectNavbar() {
      return this._element.closest(`.${CLASS_NAME_NAVBAR}`) !== null;
    }

    _getOffset() {
      const {
        offset
      } = this._config;

      if (typeof offset === 'string') {
        return offset.split(',').map(val => Number.parseInt(val, 10));
      }

      if (typeof offset === 'function') {
        return popperData => offset(popperData, this._element);
      }

      return offset;
    }

    _getPopperConfig() {
      const defaultBsPopperConfig = {
        placement: this._getPlacement(),
        modifiers: [{
          name: 'preventOverflow',
          options: {
            boundary: this._config.boundary
          }
        }, {
          name: 'offset',
          options: {
            offset: this._getOffset()
          }
        }]
      }; // Disable Popper if we have a static display

      if (this._config.display === 'static') {
        defaultBsPopperConfig.modifiers = [{
          name: 'applyStyles',
          enabled: false
        }];
      }

      return { ...defaultBsPopperConfig,
        ...(typeof this._config.popperConfig === 'function' ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig)
      };
    }

    _selectMenuItem({
      key,
      target
    }) {
      const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(isVisible);

      if (!items.length) {
        return;
      } // if target isn't included in items (e.g. when expanding the dropdown)
      // allow cycling to get the last item in case key equals ARROW_UP_KEY


      getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus();
    } // Static


    static clearMenus(event) {
      if (event && (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY)) {
        return;
      }

      const toggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE);

      for (let i = 0, len = toggles.length; i < len; i++) {
        const context = Dropdown.getInstance(toggles[i]);

        if (!context || context._config.autoClose === false) {
          continue;
        }

        if (!context._isShown()) {
          continue;
        }

        const relatedTarget = {
          relatedTarget: context._element
        };

        if (event) {
          const composedPath = event.composedPath();
          const isMenuTarget = composedPath.includes(context._menu);

          if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) {
            continue;
          } // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu


          if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY || /input|select|option|textarea|form/i.test(event.target.tagName))) {
            continue;
          }

          if (event.type === 'click') {
            relatedTarget.clickEvent = event;
          }
        }

        context._completeHide(relatedTarget);
      }
    }

    static getParentFromElement(element) {
      return getElementFromSelector(element) || element.parentNode;
    }

    static dataApiKeydownHandler(event) {
      // If not input/textarea:
      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
      // If input/textarea:
      //  - If space key => not a dropdown command
      //  - If key is other than escape
      //    - If key is not up or down => not a dropdown command
      //    - If trigger inside the menu => not a dropdown command
      if (/input|textarea/i.test(event.target.tagName) ? event.key === SPACE_KEY || event.key !== ESCAPE_KEY && (event.key !== ARROW_DOWN_KEY && event.key !== ARROW_UP_KEY || event.target.closest(SELECTOR_MENU)) : !REGEXP_KEYDOWN.test(event.key)) {
        return;
      }

      const isActive = this.classList.contains(CLASS_NAME_SHOW);

      if (!isActive && event.key === ESCAPE_KEY) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (isDisabled(this)) {
        return;
      }

      const getToggleButton = this.matches(SELECTOR_DATA_TOGGLE) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE)[0];
      const instance = Dropdown.getOrCreateInstance(getToggleButton);

      if (event.key === ESCAPE_KEY) {
        instance.hide();
        return;
      }

      if (event.key === ARROW_UP_KEY || event.key === ARROW_DOWN_KEY) {
        if (!isActive) {
          instance.show();
        }

        instance._selectMenuItem(event);

        return;
      }

      if (!isActive || event.key === SPACE_KEY) {
        Dropdown.clearMenus();
      }
    }

  }
  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */


  EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE, Dropdown.dataApiKeydownHandler);
  EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
  EventHandler.on(document, EVENT_CLICK_DATA_API, Dropdown.clearMenus);
  EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
  EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
    event.preventDefault();
    Dropdown.getOrCreateInstance(this).toggle();
  });

  (function () {
    new Responsive();
    new ProductCardColorSwatch();
    new ProductQuickvew();

    if (window.theme.pageType !== 'password' && window.theme.pageType !== 'gift_card') {
      new LoadingBar();
    }

    let sectionContainer = new SectionContainer();
    sectionContainer.register('slideshow', SlideshowSection);
    sectionContainer.register('announcement-bar', AnnouncementBarSection);
    sectionContainer.register('feature-columns', FeatureColumnsSection);
    sectionContainer.register('testimonials', TestimonialsSection);
    sectionContainer.register('featured-collection', FeaturedCollectionSection);
    sectionContainer.register('tab-collections', TabCollectionsSection);
    sectionContainer.register('featured-nav', FeaturedNavSection); // Sections used on login page

    sectionContainer.register('login', LoginSection); // Sections used on different pages

    sectionContainer.register('product-recommendations', ProductRecommendationsSection);
    sectionContainer.register('product-recentyly-viewed', ProductRecentlyViewedSection); // Sections used on collection page

    sectionContainer.register('collection', CollectionSection); // Sections used on collection page

    sectionContainer.register('product', ProductSection);
    sectionContainer.register('search', SearchSection);
    sectionContainer.register('cart', CartSection);
    sectionContainer.register('cart-drawer', CartDrawerSection); // Sections used on addresses page

    sectionContainer.register('addresses', AddressesSection);
    sectionContainer.register('featured-product', FeaturedProductSection);
    sectionContainer.register('product-quickview', ProductQuickviewSection);
    sectionContainer.register('gift-card', GiftCardSection);
  })();

  (function () {
    let windowWidth = window.innerWidth;
    let headerSection = document.getElementById('shopify-section-header');
    let announcementBarSection = document.getElementById('shopify-section-announcement-bar');
    let pageHeader = document.getElementById('PageHeader');
    window.addEventListener('resize', function () {
      let newWidth = window.innerWidth;

      if (newWidth === windowWidth) {
        return;
      }

      windowWidth = newWidth;
      document.documentElement.style.setProperty('--tg-window-height', window.innerHeight + 'px');

      if (headerSection) {
        document.documentElement.style.setProperty('--tg-header-height', headerSection.clientHeight + 'px');
        document.documentElement.style.setProperty('--tg-header-height-absolute', document.getElementById('Header').clientHeight + 'px');
      }

      if (announcementBarSection) {
        document.documentElement.style.setProperty('--tg-announcement-bar-height', announcementBarSection.clientHeight + 'px');
      }

      if (pageHeader) {
        document.documentElement.style.setProperty('--tg-page-header-height', pageHeader.clientHeight + 'px');
      }
    });
    new SearchDrawer();
  })();

})();
